var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 255.975 237.578"
    },
    viewBox: "0 0 255.975 237.578",
    height: "237.578px",
    width: "255.975px",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_5_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    id: "Layer_3_7_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.635,135.921c0-11.563-10.059-20.938-22.467-20.938c-0.194,0-0.385,0.01-0.576,0.015 c-3.917-6.135-11.102-10.245-19.318-10.245c-12.404,0-22.469,9.372-22.469,20.935c0,0.15,0.009,0.297,0.012,0.447 c-6.78,3.603-11.36,10.398-11.36,18.197c0,11.562,10.059,20.934,22.468,20.934c0.705,0,1.403-0.033,2.092-0.094 c4.122,4.648,10.358,7.617,17.335,7.617c11.471,0,20.925-8.012,22.293-18.352C78.771,150.934,83.635,143.96,83.635,135.921z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.351,174.289c-6.893,0-13.391-2.749-17.95-7.568c-0.499,0.03-0.993,0.045-1.477,0.045 c-13.216,0-23.968-10.063-23.968-22.434c0-7.766,4.326-14.995,11.353-19.075c0.247-12.172,10.902-22.004,23.964-22.004 c8.091,0,15.716,3.899,20.112,10.231c13.115,0.11,23.75,10.132,23.75,22.437c0,8.109-4.625,15.514-12.124,19.502 C71.165,166.233,61.14,174.289,49.351,174.289z M32.637,163.611l0.501,0.565c4.008,4.52,9.917,7.112,16.213,7.112 c10.575,0,19.52-7.329,20.806-17.048l0.105-0.796l0.72-0.354c6.879-3.383,11.153-9.962,11.153-17.171 c0-10.718-9.406-19.438-20.967-19.438c-0.11,0-0.219,0.004-0.327,0.008l-1.058,0.028l-0.456-0.714 c-3.762-5.892-10.68-9.552-18.054-9.552c-11.562,0-20.969,8.718-20.969,19.435l0.029,1.34l-0.814,0.432 c-6.516,3.463-10.564,9.928-10.564,16.873c0,10.716,9.406,19.434,20.968,19.434c0.637,0,1.296-0.029,1.96-0.088L32.637,163.611 z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.789,114.233c-0.193,0-0.389,0.01-0.575,0.015 c-3.141-4.918-8.383-8.534-14.573-9.775c4.898,1.229,9.023,4.208,11.562,8.175c0.161-0.004,2.416,3.886,2.583,3.886 c10.646,0,15.601,5.737,15.601,15.659c0,6.896-2.583,11.291-8.704,14.303c-1.173,8.875-9.287,15.746-19.129,15.746 c-5.99,0-11.34-2.543-14.877-6.529c-0.591,0.049-1.189,0.076-1.794,0.076c-10.649,0-19.013-5.049-19.013-14.969 c0-6.683,2.985-9.973,8.432-13.938c-0.146-0.854-0.75-8.42,1.267-10.438c4.792-4.793,6.964-8.908,11.25-11.038 c-8.414,3.025-14.385,10.627-14.385,19.535c0,0.147,0.009,0.301,0.012,0.447c-6.784,3.604-11.361,10.396-11.361,18.194 c0,11.563,10.059,20.938,22.468,20.938c0.707,0,1.401-0.035,2.093-0.101c4.121,4.646,10.356,7.617,17.336,7.617 c11.471,0,20.924-8.017,22.291-18.354c7.133-3.506,11.997-10.479,11.997-18.521C83.258,123.605,73.199,114.233,60.789,114.233z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.811,147.246c0,0,11.635,2.275,11.635,13.66c0,0,3.137,19.344-8.976,33.027h27.96 c-0.277-0.39-24.422-32.646,2.449-51.814C45.491,151.486,28.811,147.246,28.811,147.246z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.43,195.434H28.139l2.208-2.494c11.481-12.971,8.648-31.607,8.618-31.794l-0.019-0.239 c0-9.08-8.4-11.682-10.144-12.122c-0.237-0.053-0.361-0.084-0.361-0.084l0.657-2.926c0,0,0.139,0.026,0.39,0.089 c0.934,0.203,4.23,0.84,8.8,0.84c5.724,0,14.334-1.021,22.847-5.887l1.615,2.523c-6.626,4.727-10.562,10.699-11.7,17.752 c-2.419,15.004,8.333,30.236,9.566,31.924l1.744,2.385L59.43,195.434z M34.606,192.434h21.997 c-3.445-5.399-10.646-18.599-8.514-31.819c0.806-4.993,2.849-9.488,6.098-13.438c-6.07,2.011-11.711,2.526-15.898,2.526 c-0.463,0-0.913-0.006-1.35-0.017c2.654,2.275,4.973,5.784,5.006,11.102C42.206,162.524,44.379,179.122,34.606,192.434z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.178,124.404",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.904,147.212c0,0-17.649,22.793-4.085,46.722h8.611 C59.43,193.934,41.515,168.896,54.904,147.212z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.475,134.639c0-10.828-9.42-19.604-21.04-19.604c-0.183,0-0.355,0.008-0.539,0.013 c-3.669-5.744-10.396-9.595-18.091-9.595c-11.62,0-21.041,8.776-21.041,19.604c0,0.142,0.009,0.278,0.012,0.418 c-6.354,3.375-10.644,9.739-10.644,17.043c0,10.826,9.421,19.604,21.04,19.604c0.66,0,1.312-0.033,1.96-0.091 c3.858,4.354,9.698,7.136,16.233,7.136c10.733,0,19.596-7.5,20.875-17.187C248.92,148.695,253.475,142.167,253.475,134.639z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.365,170.667c-6.466,0-12.562-2.573-16.847-7.086c-0.459,0.027-0.904,0.041-1.347,0.041 c-12.429,0-22.54-9.468-22.54-21.104c0-7.289,4.053-14.077,10.637-17.92c0.262-11.426,10.271-20.645,22.536-20.645 c7.59,0,14.745,3.652,18.885,9.583c12.312,0.128,22.285,9.545,22.285,21.102c0,7.613-4.335,14.567-11.367,18.326 C241.852,163.111,232.437,170.667,221.365,170.667z M205.753,160.47l0.502,0.566c3.734,4.214,9.242,6.631,15.11,6.631 c9.857,0,18.192-6.828,19.388-15.883l0.105-0.796l0.72-0.354c6.413-3.154,10.396-9.283,10.396-15.996 c0-9.982-8.766-18.104-19.54-18.104c-0.114,0-0.224,0.004-0.336,0.007l-1.011,0.027l-0.456-0.714 c-3.508-5.491-9.955-8.902-16.827-8.902c-10.775,0-19.541,8.121-19.541,18.104l0.03,1.31l-0.814,0.433 c-6.074,3.227-9.848,9.25-9.848,15.719c0,9.982,8.766,18.104,19.54,18.104c0.587,0,1.185-0.027,1.827-0.085L205.753,160.47z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.081,114.33c-0.188,0-0.358,0.008-0.539,0.012 c-2.94-4.606-7.854-7.992-13.646-9.154c4.586,1.15,8.449,3.94,10.822,7.655c0.154-0.004,2.263,3.639,2.419,3.639 c9.971,0,14.608,5.374,14.608,14.665c0,6.459-2.42,10.574-8.148,13.396c-1.1,8.312-8.698,14.738-17.914,14.738 c-5.604,0-10.619-2.381-13.934-6.113c-0.562,0.047-1.112,0.068-1.687,0.068c-9.975,0-17.806-4.728-17.806-14.017 c0-6.258,2.8-9.34,7.896-13.055c-0.14-0.81-0.698-7.888,1.188-9.772c4.485-4.488,6.521-8.343,10.534-10.337 c-7.879,2.833-13.473,9.952-13.473,18.291c0,0.14,0.008,0.275,0.014,0.419c-6.354,3.372-10.646,9.735-10.646,17.041 c0,10.823,9.421,19.604,21.041,19.604c0.661,0,1.313-0.033,1.959-0.093c3.859,4.354,9.699,7.138,16.234,7.138 c10.739,0,19.594-7.5,20.875-17.188c6.68-3.285,11.229-9.812,11.229-17.342C253.122,123.105,243.702,114.33,232.081,114.33z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.135,145.24c0,0,10.896,2.135,10.896,12.799c0,0,2.938,18.107-8.402,30.928h26.184 c-0.26-0.357-22.87-30.564,2.294-48.521C217.754,149.214,202.135,145.24,202.135,145.24z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.813,190.467H201.3l2.205-2.494c10.718-12.116,8.073-29.521,8.046-29.694l-0.02-0.239 c0-8.434-7.804-10.854-9.429-11.267c-0.222-0.049-0.338-0.078-0.338-0.078l0.658-2.926c0,0,0.131,0.024,0.367,0.083 c0.875,0.191,3.956,0.787,8.23,0.787c5.347,0,13.39-0.953,21.342-5.495l1.615,2.523c-6.197,4.422-9.872,10.01-10.925,16.608 c-2.245,14.081,7.802,28.219,8.954,29.784l1.76,2.39L230.813,190.467z M207.752,187.467h20.23 c-3.271-5.139-9.858-17.334-7.893-29.664c0.735-4.61,2.591-8.768,5.539-12.433c-6.078,1.964-11.618,2.346-15.621,2.258 c2.418,2.149,4.49,5.412,4.523,10.293C214.781,159.586,216.784,175.011,207.752,187.467z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.036,123.855",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,145.212c0,0-16.526,21.345-3.819,43.752h8.062 C230.808,188.964,214.032,165.518,226.57,145.212z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.772,136.398c0-16.621-14.461-30.094-32.299-30.094c-0.278,0-0.554,0.012-0.828,0.02 c-5.632-8.816-15.959-14.729-27.771-14.729c-17.838,0-32.301,13.475-32.301,30.097c0,0.215,0.014,0.43,0.018,0.646 c-9.755,5.181-16.339,14.942-16.339,26.156c0,16.618,14.462,30.098,32.3,30.098c1.014,0,2.018-0.049,3.008-0.139 c5.926,6.688,14.894,10.948,24.921,10.948c16.489,0,30.081-11.515,32.048-26.379 C209.782,157.98,216.772,147.953,216.772,136.398z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.481,190.9c-9.841,0-19.103-3.961-25.536-10.895c-0.807,0.057-1.608,0.085-2.393,0.085 c-18.637,0-33.8-14.175-33.8-31.598c0-11.044,6.23-21.322,16.322-27.035c0.134-17.316,15.245-31.363,33.8-31.363 c11.534,0,22.397,5.616,28.565,14.71c0.012,0,0.022,0,0.033,0c18.637,0,33.799,14.173,33.799,31.594 c0,11.518-6.635,22.027-17.371,27.61C198.443,179.395,184.225,190.9,167.481,190.9z M143.18,176.89l0.503,0.567 c5.88,6.637,14.554,10.443,23.798,10.443c15.531,0,28.669-10.78,30.561-25.075l0.105-0.796l0.72-0.354 c10.119-4.975,16.405-14.66,16.405-25.277c0-15.767-13.816-28.594-30.799-28.594c-0.184,0-0.366,0.006-0.548,0.012l-1.088,0.03 l-0.456-0.714c-5.531-8.659-15.688-14.037-26.507-14.037c-16.983,0-30.801,12.829-30.801,28.597 c0,0.106,0.004,0.213,0.008,0.32l0.026,1.219l-0.813,0.432c-9.587,5.091-15.542,14.605-15.542,24.831 c0,15.769,13.817,28.598,30.8,28.598c0.937,0,1.903-0.045,2.872-0.133L143.18,176.89z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.931,105.221c-0.276,0-0.552,0.012-0.827,0.02 c-4.516-7.07-12.051-12.27-20.949-14.052c7.041,1.767,12.976,6.049,16.614,11.751c0.237-0.006,3.479,5.586,3.713,5.586 c15.312,0,22.434,8.248,22.434,22.512c0,9.912-3.72,16.23-12.518,20.562c-1.687,12.754-13.353,22.635-27.5,22.635 c-8.605,0-16.302-3.652-21.387-9.396c-0.851,0.07-1.71,0.113-2.58,0.113c-15.31,0-27.332-7.255-27.332-21.517 c0-9.604,4.298-14.336,12.12-20.039c-0.209-1.233-1.077-12.104,1.82-15.002c6.89-6.89,10.011-12.808,16.174-15.868 c-12.096,4.35-20.679,15.277-20.679,28.08c0,0.216,0.011,0.433,0.017,0.646c-9.756,5.178-16.34,14.945-16.34,26.156 c0,16.619,14.461,30.098,32.3,30.098c1.017,0,2.017-0.049,3.008-0.137c5.925,6.688,14.895,10.947,24.922,10.947 c16.487,0,30.078-11.515,32.046-26.379c10.259-5.043,17.244-15.068,17.244-26.623 C216.23,118.694,201.77,105.221,183.931,105.221z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.959,152.676c0,0,16.727,3.271,16.727,19.643c0,0,4.504,27.811-12.899,47.479h40.19 c-0.396-0.558-35.104-46.922,3.521-74.483C161.938,158.775,137.959,152.676,137.959,152.676z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.977,221.298h-43.521l2.207-2.494c16.711-18.887,12.585-45.975,12.542-46.246l-0.02-0.239 c0-13.556-12.514-17.421-15.085-18.07c-0.336-0.073-0.512-0.118-0.512-0.118l0.658-2.926c0,0,0.192,0.037,0.539,0.123 c1.35,0.295,6.156,1.228,12.811,1.228c8.305,0,20.8-1.482,33.157-8.543l1.615,2.523c-9.67,6.9-15.418,15.63-17.083,25.945 c-3.521,21.815,12.075,43.933,13.865,46.382l1.742,2.386L181.977,221.298z M144.976,218.298h34.146 c-4.569-6.937-15.971-26.632-12.796-46.295c1.268-7.854,4.704-14.841,10.251-20.866c-9.524,3.546-18.482,4.418-24.979,4.418 c-1.404,0-2.726-0.039-3.956-0.104c4.314,3.099,8.506,8.285,8.545,16.749C156.523,174.407,159.876,199.073,144.976,218.298z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.552,119.846",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.472,152.63c0,0-25.378,32.767-5.873,67.164h12.378 C181.977,219.796,156.223,183.803,175.472,152.63z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.936,137.51c0-13.646-11.873-24.707-26.517-24.707c-0.229,0-0.454,0.01-0.685,0.016 c-4.619-7.238-13.102-12.092-22.8-12.092c-14.644,0-26.518,11.063-26.518,24.707c0,0.178,0.012,0.354,0.015,0.528 c-8.01,4.252-13.414,12.271-13.414,21.478c0,13.646,11.872,24.707,26.521,24.707c0.832,0,1.65-0.041,2.469-0.104 c4.864,5.48,12.224,8.98,20.46,8.98c13.537,0,24.695-9.451,26.309-21.648C139.195,155.229,144.936,146.998,144.936,137.51z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.468,182.523c-8.108,0-15.747-3.247-21.08-8.935c-0.66,0.038-1.27,0.058-1.849,0.058 c-15.451,0-28.021-11.757-28.021-26.207c0-9.119,5.111-17.604,13.402-22.356c0.202-14.289,12.691-25.856,28.015-25.856 c9.513,0,18.472,4.606,23.595,12.076c15.398,0.056,27.906,11.791,27.906,26.207c0,9.509-5.455,18.196-14.289,22.851 C130.049,173.051,118.298,182.523,104.468,182.523z M84.636,170.49l0.494,0.557c4.781,5.387,11.829,8.477,19.338,8.477 c12.617,0,23.288-8.746,24.821-20.345l0.105-0.795l0.719-0.354c8.218-4.048,13.322-11.91,13.322-20.52 c0-12.797-11.223-23.207-25.017-23.207c-0.144,0-0.285,0.005-0.428,0.009l-1.065,0.028l-0.456-0.714 c-4.487-7.031-12.739-11.399-21.535-11.399c-13.795,0-25.018,10.411-25.018,23.207l0.03,1.422l-0.812,0.432 c-7.783,4.131-12.617,11.854-12.617,20.152c0,12.797,11.225,23.207,25.021,23.207c0.721,0,1.469-0.031,2.354-0.1L84.636,170.49 z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.973,111.916c-0.228,0-0.452,0.009-0.679,0.015 c-3.707-5.805-9.896-10.072-17.199-11.537c5.78,1.45,10.648,4.966,13.641,9.647c0.194-0.005,2.854,4.586,3.053,4.586 c12.562,0,18.414,6.771,18.414,18.479c0,8.143-3.055,13.326-10.271,16.882c-1.384,10.476-10.961,18.584-22.576,18.584 c-7.064,0-13.384-3.005-17.559-7.716c-0.698,0.063-1.404,0.1-2.118,0.1c-12.568,0-22.438-5.957-22.438-17.664 c0-7.889,3.527-11.771,9.948-16.451c-0.171-1.019-0.884-9.938,1.496-12.315c5.655-5.657,8.218-10.515,13.277-13.027 c-9.935,3.57-16.979,12.542-16.979,23.053c0,0.18,0.015,0.354,0.02,0.527c-8.016,4.25-13.415,12.271-13.415,21.479 c0,13.646,11.873,24.707,26.518,24.707c0.834,0,1.655-0.041,2.47-0.108c4.863,5.487,12.228,8.987,20.462,8.987 c13.534,0,24.691-9.451,26.312-21.655c8.418-4.144,14.158-12.371,14.158-21.854 C144.491,122.977,132.618,111.916,117.973,111.916z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.231,150.875c0,0,13.731,2.688,13.731,16.129c0,0,3.697,22.822-10.595,38.979h33 c-0.328-0.455-28.824-38.521,2.89-61.149C99.918,155.88,80.231,150.875,80.231,150.875z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.367,207.482h-36.33l2.206-2.494c13.663-15.445,10.273-37.523,10.238-37.744l-0.02-0.24 c0-10.928-10.095-14.05-12.181-14.577c-0.277-0.062-0.42-0.098-0.42-0.098l0.658-2.926c0,0,0.16,0.03,0.449,0.103 c1.106,0.241,5.026,1,10.458,1c6.787,0,16.995-1.21,27.088-6.976l1.615,2.523c-7.892,5.631-12.576,12.752-13.923,21.165 c-2.861,17.866,9.887,35.854,11.351,37.847l1.753,2.388L116.367,207.482z M86.529,204.482h26.991 c-3.932-6.047-12.823-21.845-10.278-37.738c0.989-6.177,3.597-11.705,7.779-16.518c-7.478,2.621-14.467,3.279-19.597,3.279 c-0.833,0-1.63-0.017-2.39-0.046c3.334,2.628,6.391,6.833,6.427,13.426C95.755,168.822,98.409,188.729,86.529,204.482z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,123.921",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.027,150.837c0,0-20.835,26.897-4.816,55.142h10.162 C116.369,205.979,95.225,176.428,111.027,150.837z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.159,161.646c0-12.345-10.74-22.353-23.988-22.353c-0.202,0-0.406,0.01-0.61,0.017 c-4.187-6.55-11.854-10.938-20.625-10.938c-13.248,0-23.98,10.008-23.98,22.353c0,0.162,0.012,0.315,0.014,0.479 c-7.244,3.85-12.135,11.104-12.135,19.432c0,12.349,10.731,22.354,23.98,22.354c0.753,0,1.497-0.037,2.229-0.104 c4.396,4.97,11.062,8.136,18.512,8.136c12.245,0,22.339-8.554,23.799-19.593C246.965,177.673,252.159,170.229,252.159,161.646z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.556,202.521c-7.358,0-14.285-2.938-19.126-8.084c-0.545,0.035-1.086,0.053-1.615,0.053 c-14.05,0-25.48-10.701-25.48-23.854c0-8.272,4.622-15.974,12.125-20.31c0.228-12.969,11.569-23.454,25.477-23.454 c8.619,0,16.744,4.164,21.418,10.923c13.971,0.092,25.306,10.756,25.306,23.852c0,8.629-4.937,16.518-12.936,20.767 C238.783,193.932,228.112,202.521,215.556,202.521z M197.664,191.322l0.504,0.569c4.288,4.849,10.626,7.63,17.388,7.63 c11.341,0,20.933-7.862,22.312-18.289l0.105-0.794l0.718-0.354c7.383-3.644,11.969-10.708,11.969-18.438 c0-11.498-10.088-20.853-22.488-20.853c-0.137,0-0.274,0.006-0.413,0.011l-1.001,0.033l-0.46-0.72 c-4.04-6.32-11.459-10.246-19.361-10.246c-12.396,0-22.48,9.354-22.48,20.853l0.024,1.375l-0.807,0.429 c-6.994,3.717-11.339,10.655-11.339,18.107c0,11.499,10.085,20.854,22.48,20.854c0.68,0,1.384-0.033,2.092-0.099 L197.664,191.322z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.767,138.49c-0.206,0-0.409,0.014-0.614,0.018 c-3.354-5.25-8.944-9.109-15.558-10.438c5.229,1.312,9.633,4.492,12.339,8.729c0.175-0.004,2.579,4.146,2.757,4.146 c11.368,0,16.655,6.123,16.655,16.721c0,7.359-2.757,12.057-9.291,15.271c-1.252,9.474-9.915,16.812-20.423,16.812 c-6.396,0-12.106-2.723-15.884-6.979c-0.631,0.056-1.271,0.086-1.916,0.086c-11.368,0-20.299-5.39-20.299-15.979 c0-7.136,3.188-10.646,9.002-14.886c-0.156-0.918-0.809-8.985,1.353-11.141c5.116-5.117,7.438-9.518,12.011-11.785 c-8.979,3.229-15.354,11.347-15.354,20.854c0,0.158,0.013,0.314,0.017,0.479c-7.246,3.851-12.138,11.104-12.138,19.433 c0,12.344,10.738,22.354,23.988,22.354c0.754,0,1.491-0.035,2.229-0.104c4.401,4.967,11.063,8.133,18.509,8.133 c12.245,0,22.338-8.557,23.804-19.594c7.61-3.74,12.812-11.188,12.812-19.771C251.754,148.5,241.016,138.49,227.767,138.49z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.625,173.734c0,0,12.422,2.434,12.422,14.588c0,0,3.345,20.646-9.584,35.262h29.853 c-0.296-0.41-26.068-34.85,2.615-55.316C211.435,178.266,193.625,173.734,193.625,173.734z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.316,225.084h-33.182l2.206-2.494c12.288-13.892,9.258-33.829,9.227-34.029l-0.02-0.238 c0-9.772-9.036-12.571-10.909-13.045c-0.251-0.056-0.383-0.089-0.383-0.089l0.658-2.926c0,0,0.147,0.028,0.411,0.094 c0.999,0.218,4.532,0.902,9.431,0.902c6.121,0,15.329-1.092,24.432-6.294l1.615,2.523c-7.104,5.07-11.322,11.479-12.535,19.051 c-2.58,16.109,8.92,32.335,10.239,34.132l1.754,2.388L226.316,225.084z M199.609,222.084h23.868 c-3.632-5.64-11.452-19.78-9.172-34.02c0.872-5.443,3.125-10.332,6.725-14.609c-6.595,2.235-12.736,2.804-17.274,2.804 c-0.601,0-1.181-0.01-1.74-0.026c2.908,2.41,5.497,6.181,5.532,11.972C207.82,190.017,210.172,207.852,199.609,222.084z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.493,149.354",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.484,173.703c0,0-18.847,24.334-4.356,49.881h9.188 C226.315,223.583,207.188,196.852,221.484,173.703z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.893,159.796c0-13.11-11.408-23.737-25.479-23.737c-0.225,0-0.438,0.008-0.653,0.015 c-4.443-6.952-12.589-11.61-21.907-11.61c-14.066,0-25.479,10.629-25.479,23.733c0,0.171,0.011,0.336,0.015,0.509 C6.693,152.787,1.5,160.496,1.5,169.339c0,13.106,11.407,23.736,25.479,23.736c0.8,0,1.59-0.041,2.372-0.104 c4.674,5.271,11.745,8.639,19.659,8.639c13.007,0,23.729-9.081,25.279-20.809C82.378,176.818,87.893,168.912,87.893,159.796z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.01,203.109c-7.796,0-15.142-3.122-20.277-8.591c-0.62,0.038-1.198,0.057-1.754,0.057 C12.103,194.575,0,183.254,0,169.339c0-8.774,4.911-16.937,12.878-21.513c0.211-13.744,12.231-24.863,26.976-24.863 c9.146,0,17.763,4.423,22.702,11.596c14.811,0.072,26.837,11.365,26.837,25.237c0,9.149-5.242,17.507-13.734,21.99 C73.627,193.997,62.318,203.109,49.01,203.109z M29.976,191.415l0.497,0.561c4.583,5.169,11.339,8.134,18.537,8.134 c12.094,0,22.323-8.386,23.792-19.505l0.105-0.795l0.719-0.354c7.875-3.877,12.766-11.41,12.766-19.659 c0-12.262-10.757-22.237-23.979-22.237c-0.183,0-0.359,0.006-0.534,0.012l-0.853,0.027l-0.53-0.717 c-4.305-6.734-12.214-10.918-20.644-10.918c-13.222,0-23.979,9.974-23.979,22.233l0.035,1.4l-0.818,0.434 C7.634,153.986,3,161.385,3,169.339c0,12.261,10.757,22.236,23.979,22.236c0.689,0,1.425-0.032,2.251-0.1L29.976,191.415z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.985,135.203c-0.219,0-0.435,0.01-0.647,0.018 c-3.563-5.578-9.506-9.68-16.525-11.088c5.554,1.395,10.231,4.771,13.106,9.271c0.186-0.004,2.734,4.406,2.928,4.406 c12.076,0,17.692,6.506,17.692,17.758c0,7.82-2.934,12.806-9.87,16.222c-1.33,10.063-10.531,17.854-21.693,17.854 c-6.792,0-12.857-2.886-16.871-7.412c-0.67,0.058-1.348,0.092-2.035,0.092c-12.071,0-21.561-5.723-21.561-16.975 c0-7.574,3.391-11.311,9.561-15.811c-0.165-0.979-0.85-9.552,1.438-11.836c5.435-5.438,7.896-10.104,12.758-12.52 c-9.541,3.434-16.312,12.051-16.312,22.146c0,0.17,0.011,0.338,0.015,0.508c-7.696,4.086-12.89,11.795-12.89,20.641 c0,13.105,11.403,23.734,25.479,23.734c0.801,0,1.591-0.037,2.373-0.104c4.674,5.271,11.745,8.64,19.659,8.64 c13.006,0,23.728-9.08,25.273-20.81c8.094-3.979,13.604-11.895,13.604-21.002C87.466,145.83,76.058,135.203,61.985,135.203z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.723,172.635c0,0,13.193,2.584,13.193,15.495c0,0,3.553,21.933-10.184,37.451H60.44 c-0.312-0.438-27.689-37.017,2.777-58.761C44.638,177.445,25.723,172.635,25.723,172.635z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.44,227.081H25.402l2.208-2.494c13.086-14.784,9.86-36.006,9.826-36.219l-0.019-0.238 c0-10.453-9.662-13.442-11.659-13.947c-0.266-0.059-0.404-0.094-0.404-0.094l0.658-2.926c0,0,0.154,0.029,0.432,0.099 c1.061,0.231,4.818,0.959,10.028,0.959c6.515,0,16.313-1.162,26.001-6.702l1.616,2.522c-7.56,5.396-12.05,12.216-13.348,20.271 c-2.754,17.103,9.479,34.428,10.883,36.347l1.745,2.386L60.44,227.081z M31.889,224.081h25.712 c-3.807-5.892-12.268-21.056-9.822-36.245c0.944-5.862,3.402-11.115,7.334-15.7c-7.115,2.464-13.755,3.085-18.642,3.085 c-0.733,0-1.438-0.013-2.113-0.037c3.159,2.539,6.021,6.566,6.057,12.828C40.701,189.898,43.23,208.957,31.889,224.081z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.078,146.736",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.313,172.6c0,0-20.02,25.849-4.633,52.981h9.764 C60.443,225.583,40.129,197.189,55.313,172.6z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    id: "Layer_3_6_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.635,135.921c0-11.563-10.059-20.938-22.467-20.938c-0.194,0-0.385,0.01-0.576,0.015 c-3.917-6.135-11.102-10.245-19.318-10.245c-12.404,0-22.469,9.372-22.469,20.935c0,0.15,0.009,0.297,0.012,0.447 c-6.78,3.603-11.36,10.398-11.36,18.197c0,11.562,10.059,20.934,22.468,20.934c0.705,0,1.403-0.033,2.092-0.094 c4.122,4.648,10.358,7.617,17.335,7.617c11.471,0,20.925-8.012,22.293-18.352C79.771,150.934,84.635,143.96,84.635,135.921z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.351,174.289c-6.893,0-13.391-2.749-17.95-7.568c-0.499,0.03-0.993,0.045-1.477,0.045 c-13.216,0-23.968-10.063-23.968-22.434c0-7.766,4.326-14.995,11.353-19.075c0.247-12.172,10.902-22.004,23.964-22.004 c8.091,0,15.716,3.899,20.112,10.231c13.115,0.11,23.75,10.132,23.75,22.437c0,8.109-4.625,15.514-12.124,19.502 C72.165,166.233,62.14,174.289,50.351,174.289z M33.637,163.611l0.501,0.565c4.008,4.52,9.917,7.112,16.213,7.112 c10.575,0,19.52-7.329,20.806-17.048l0.105-0.796l0.72-0.354c6.879-3.383,11.153-9.962,11.153-17.171 c0-10.718-9.406-19.438-20.967-19.438c-0.11,0-0.219,0.004-0.327,0.008l-1.058,0.028l-0.456-0.714 c-3.762-5.892-10.68-9.552-18.054-9.552c-11.562,0-20.969,8.718-20.969,19.435l0.029,1.34l-0.814,0.432 c-6.516,3.463-10.564,9.928-10.564,16.873c0,10.716,9.406,19.434,20.968,19.434c0.637,0,1.296-0.029,1.96-0.088L33.637,163.611 z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.789,114.233c-0.193,0-0.389,0.01-0.575,0.015 c-3.141-4.918-8.383-8.534-14.573-9.775c4.898,1.229,9.023,4.208,11.562,8.175c0.161-0.004,2.416,3.886,2.583,3.886 c10.646,0,15.601,5.737,15.601,15.659c0,6.896-2.583,11.291-8.704,14.303c-1.173,8.875-9.287,15.746-19.129,15.746 c-5.99,0-11.34-2.543-14.877-6.531c-0.591,0.051-1.189,0.078-1.794,0.078c-10.649,0-19.013-5.049-19.013-14.969 c0-6.683,2.985-9.973,8.432-13.938c-0.146-0.856-0.75-8.421,1.267-10.438c4.792-4.793,6.964-8.908,11.25-11.038 C25.4,108.43,19.43,116.032,19.43,124.939c0,0.146,0.009,0.299,0.012,0.446C12.655,128.99,8.08,135.781,8.08,143.581 c0,11.563,10.059,20.938,22.468,20.938c0.707,0,1.398-0.035,2.093-0.099c4.121,4.646,10.356,7.617,17.336,7.617 c11.469,0,20.924-8.017,22.291-18.354c7.133-3.506,11.997-10.479,11.997-18.521C84.258,123.605,74.199,114.233,61.789,114.233z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.811,147.246c0,0,11.635,2.275,11.635,13.66c0,0,3.137,19.344-8.976,33.027h27.96 c-0.277-0.39-24.422-32.646,2.449-51.814C46.491,151.486,29.811,147.246,29.811,147.246z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.43,195.434H29.139l2.208-2.494c11.481-12.971,8.648-31.607,8.618-31.794l-0.019-0.239 c0-9.08-8.4-11.682-10.144-12.122c-0.237-0.053-0.361-0.084-0.361-0.084l0.657-2.926c0,0,0.139,0.026,0.39,0.089 c0.934,0.203,4.23,0.84,8.8,0.84c5.724,0,14.334-1.021,22.847-5.887l1.615,2.523c-6.626,4.728-10.562,10.7-11.7,17.753 c-2.419,15.003,8.333,30.235,9.566,31.923l1.744,2.385L60.43,195.434z M35.606,192.434h21.997 c-3.445-5.398-10.646-18.598-8.514-31.818c0.805-4.993,2.849-9.489,6.099-13.438c-6.07,2.011-11.712,2.526-15.899,2.526 c-0.463,0-0.913-0.006-1.35-0.017c2.654,2.275,4.973,5.784,5.006,11.102C43.206,162.524,45.379,179.122,35.606,192.434z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.178,124.404",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.904,147.212c0,0-17.649,22.793-4.085,46.722h8.611 C60.43,193.934,42.515,168.896,55.904,147.212z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.475,134.639c0-10.828-9.42-19.604-21.04-19.604c-0.183,0-0.355,0.008-0.539,0.013 c-3.669-5.744-10.396-9.595-18.091-9.595c-11.62,0-21.041,8.776-21.041,19.604c0,0.142,0.009,0.278,0.012,0.418 c-6.354,3.375-10.644,9.739-10.644,17.043c0,10.826,9.421,19.604,21.04,19.604c0.66,0,1.312-0.033,1.96-0.091 c3.858,4.354,9.698,7.136,16.233,7.136c10.734,0,19.596-7.5,20.875-17.187C249.92,148.695,254.475,142.167,254.475,134.639z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.365,170.667c-6.467,0-12.562-2.573-16.847-7.086c-0.46,0.027-0.904,0.041-1.347,0.041 c-12.429,0-22.54-9.468-22.54-21.104c0-7.289,4.053-14.077,10.637-17.92c0.262-11.426,10.271-20.645,22.536-20.645 c7.59,0,14.745,3.652,18.885,9.583c12.312,0.128,22.285,9.545,22.285,21.102c0,7.613-4.335,14.567-11.367,18.326 C242.852,163.111,233.437,170.667,222.365,170.667z M206.753,160.47l0.502,0.566c3.733,4.214,9.241,6.631,15.11,6.631 c9.857,0,18.192-6.828,19.388-15.883l0.105-0.796l0.72-0.354c6.413-3.154,10.396-9.283,10.396-15.996 c0-9.982-8.766-18.104-19.54-18.104c-0.114,0-0.224,0.004-0.336,0.007l-1.011,0.027l-0.456-0.714 c-3.508-5.491-9.955-8.902-16.827-8.902c-10.775,0-19.541,8.121-19.541,18.104l0.03,1.31l-0.814,0.433 c-6.074,3.227-9.848,9.25-9.848,15.719c0,9.982,8.766,18.104,19.54,18.104c0.587,0,1.185-0.027,1.827-0.085L206.753,160.47z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.081,114.33c-0.188,0-0.358,0.008-0.539,0.012 c-2.94-4.606-7.854-7.992-13.646-9.154c4.586,1.15,8.449,3.94,10.822,7.655c0.154-0.004,2.263,3.639,2.419,3.639 c9.971,0,14.608,5.374,14.608,14.665c0,6.459-2.42,10.574-8.148,13.396c-1.1,8.312-8.698,14.738-17.914,14.738 c-5.604,0-10.619-2.381-13.934-6.113c-0.561,0.047-1.112,0.068-1.686,0.068c-9.975,0-17.806-4.728-17.806-14.017 c0-6.256,2.8-9.338,7.896-13.055c-0.141-0.808-0.699-7.887,1.188-9.771c4.486-4.488,6.521-8.343,10.535-10.337 c-7.879,2.833-13.471,9.952-13.471,18.292c0,0.139,0.006,0.274,0.012,0.418c-6.355,3.373-10.646,9.735-10.646,17.041 c0,10.823,9.42,19.604,21.041,19.604c0.661,0,1.313-0.031,1.959-0.088c3.859,4.354,9.699,7.133,16.234,7.133 c10.74,0,19.594-7.5,20.875-17.188c6.68-3.285,11.23-9.812,11.23-17.342C254.122,123.105,244.702,114.33,233.081,114.33z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.135,145.24c0,0,10.896,2.135,10.896,12.799c0,0,2.938,18.107-8.402,30.928h26.184 c-0.26-0.357-22.87-30.564,2.294-48.521C218.754,149.214,203.135,145.24,203.135,145.24z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.813,190.467H202.3l2.205-2.494c10.718-12.116,8.073-29.521,8.046-29.694l-0.02-0.239 c0-8.434-7.804-10.854-9.429-11.267c-0.222-0.049-0.338-0.078-0.338-0.078l0.658-2.926c0,0,0.131,0.024,0.367,0.083 c0.875,0.191,3.956,0.787,8.23,0.787c5.347,0,13.39-0.953,21.342-5.495l1.615,2.523c-6.197,4.422-9.872,10.01-10.925,16.608 c-2.245,14.081,7.802,28.219,8.954,29.784l1.76,2.39L231.813,190.467z M208.752,187.467h20.23 c-3.271-5.139-9.858-17.334-7.893-29.664c0.735-4.61,2.591-8.768,5.539-12.433c-6.078,1.964-11.621,2.346-15.621,2.258 c2.418,2.149,4.49,5.412,4.523,10.293C215.781,159.586,217.784,175.011,208.752,187.467z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.036,123.855",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.57,145.212c0,0-16.526,21.345-3.819,43.752h8.062 C231.808,188.964,215.032,165.518,227.57,145.212z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M217.772,136.398c0-16.621-14.461-30.094-32.299-30.094c-0.278,0-0.554,0.012-0.828,0.02 c-5.632-8.816-15.959-14.729-27.771-14.729c-17.838,0-32.301,13.475-32.301,30.097c0,0.215,0.014,0.43,0.018,0.646 c-9.755,5.181-16.339,14.944-16.339,26.156c0,16.62,14.462,30.099,32.3,30.099c1.014,0,2.018-0.052,3.008-0.14 c5.926,6.688,14.894,10.95,24.921,10.95c16.489,0,30.081-11.515,32.048-26.379C210.782,157.98,217.772,147.953,217.772,136.398 z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.481,190.902c-9.84,0-19.102-3.962-25.537-10.896c-0.825,0.058-1.613,0.086-2.392,0.086 c-18.637,0-33.8-14.175-33.8-31.599c0-11.044,6.23-21.322,16.322-27.035c0.134-17.316,15.245-31.363,33.8-31.363 c11.534,0,22.397,5.616,28.565,14.71c0.012,0,0.022,0,0.033,0c18.637,0,33.799,14.173,33.799,31.594 c0,11.517-6.635,22.027-17.371,27.612C199.443,179.396,185.225,190.902,168.481,190.902z M144.181,176.892l0.502,0.565 c5.881,6.639,14.555,10.445,23.798,10.445c15.531,0,28.669-10.78,30.561-25.075l0.105-0.796l0.72-0.354 c10.119-4.977,16.405-14.663,16.405-25.279c0-15.767-13.816-28.594-30.799-28.594c-0.184,0-0.366,0.006-0.548,0.012 l-1.088,0.03l-0.456-0.714c-5.531-8.659-15.688-14.037-26.507-14.037c-16.983,0-30.801,12.829-30.801,28.597 c0,0.106,0.004,0.213,0.008,0.32l0.026,1.219l-0.813,0.432c-9.587,5.091-15.542,14.605-15.542,24.831 c0,15.77,13.817,28.599,30.8,28.599c0.92,0,1.861-0.044,2.875-0.134L144.181,176.892z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.931,105.221c-0.276,0-0.552,0.012-0.827,0.02 c-4.516-7.07-12.051-12.27-20.949-14.052c7.041,1.767,12.976,6.049,16.614,11.751c0.237-0.006,3.479,5.586,3.713,5.586 c15.312,0,22.434,8.248,22.434,22.512c0,9.912-3.72,16.23-12.518,20.562c-1.687,12.754-13.353,22.635-27.5,22.635 c-8.605,0-16.302-3.652-21.387-9.396c-0.851,0.07-1.71,0.113-2.58,0.113c-15.31,0-27.332-7.255-27.332-21.517 c0-9.604,4.298-14.336,12.12-20.039c-0.209-1.233-1.077-12.104,1.82-15.002c6.89-6.89,10.011-12.808,16.174-15.868 c-12.096,4.35-20.679,15.277-20.679,28.08c0,0.216,0.011,0.433,0.017,0.646c-9.756,5.178-16.34,14.945-16.34,26.156 c0,16.619,14.461,30.098,32.3,30.098c1.017,0,2.017-0.049,3.008-0.135c5.925,6.688,14.895,10.945,24.922,10.945 c16.487,0,30.078-11.515,32.046-26.379c10.259-5.043,17.244-15.066,17.244-26.623 C217.23,118.694,202.77,105.221,184.931,105.221z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.959,152.676c0,0,16.727,3.271,16.727,19.643c0,0,4.504,27.809-12.899,47.479h40.19 c-0.396-0.555-35.104-46.922,3.521-74.483C162.938,158.775,138.959,152.676,138.959,152.676z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.977,221.298h-43.521l2.207-2.494c16.711-18.889,12.585-45.975,12.542-46.246l-0.02-0.239 c0-13.556-12.514-17.421-15.085-18.07c-0.336-0.073-0.512-0.118-0.512-0.118l0.658-2.926c0,0,0.192,0.037,0.539,0.123 c1.35,0.295,6.156,1.228,12.811,1.228c8.305,0,20.8-1.482,33.157-8.543l1.615,2.523c-9.675,6.903-15.423,15.638-17.085,25.96 c-3.517,21.84,12.08,43.926,13.87,46.372l1.745,2.386L182.977,221.298z M145.976,218.298h34.143 c-4.57-6.931-15.965-26.6-12.796-46.28c1.266-7.86,4.704-14.852,10.254-20.881c-9.524,3.546-18.482,4.418-24.979,4.418 c-1.404,0-2.726-0.039-3.956-0.104c4.314,3.099,8.506,8.285,8.545,16.749C157.523,174.407,160.876,199.072,145.976,218.298z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.552,119.846",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.472,152.63c0,0-25.378,32.767-5.873,67.164h12.378 C182.977,219.796,157.223,183.803,176.472,152.63z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.936,137.51c0-13.646-11.873-24.707-26.517-24.707c-0.229,0-0.454,0.01-0.685,0.016 c-4.619-7.238-13.102-12.092-22.8-12.092c-14.644,0-26.518,11.063-26.518,24.707c0,0.178,0.012,0.354,0.015,0.528 c-8.01,4.252-13.414,12.271-13.414,21.478c0,13.646,11.872,24.707,26.521,24.707c0.832,0,1.65-0.041,2.469-0.104 c4.864,5.482,12.224,8.982,20.46,8.982c13.537,0,24.695-9.45,26.309-21.65C140.195,155.229,145.936,146.998,145.936,137.51z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.468,182.525c-8.108,0-15.748-3.248-21.081-8.937c-0.66,0.038-1.27,0.058-1.848,0.058 c-15.451,0-28.021-11.757-28.021-26.207c0-9.119,5.111-17.604,13.402-22.356c0.202-14.289,12.691-25.856,28.015-25.856 c9.513,0,18.472,4.606,23.595,12.076c15.398,0.056,27.906,11.791,27.906,26.207c0,9.509-5.455,18.196-14.289,22.851 C131.05,173.052,119.299,182.525,105.468,182.525z M85.636,170.49l0.494,0.558c4.78,5.388,11.829,8.478,19.338,8.478 c12.617,0,23.288-8.747,24.821-20.347l0.105-0.795l0.719-0.354c8.218-4.048,13.322-11.91,13.322-20.52 c0-12.797-11.223-23.207-25.017-23.207c-0.144,0-0.285,0.005-0.428,0.009l-1.065,0.028l-0.456-0.714 c-4.487-7.031-12.739-11.399-21.535-11.399c-13.795,0-25.018,10.411-25.018,23.207l0.03,1.422l-0.812,0.432 c-7.783,4.131-12.617,11.854-12.617,20.152c0,12.797,11.225,23.207,25.021,23.207c0.721,0,1.469-0.031,2.354-0.1L85.636,170.49 z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.973,111.916c-0.228,0-0.452,0.009-0.679,0.015 c-3.707-5.805-9.896-10.072-17.199-11.537c5.78,1.45,10.648,4.966,13.641,9.647c0.194-0.005,2.854,4.586,3.053,4.586 c12.562,0,18.414,6.771,18.414,18.479c0,8.143-3.055,13.326-10.271,16.882c-1.384,10.476-10.961,18.584-22.576,18.584 c-7.064,0-13.384-3.005-17.559-7.716c-0.698,0.063-1.404,0.1-2.118,0.1c-12.568,0-22.438-5.957-22.438-17.664 c0-7.889,3.527-11.771,9.948-16.451c-0.171-1.019-0.884-9.938,1.496-12.315c5.655-5.657,8.218-10.515,13.277-13.027 c-9.935,3.57-16.979,12.542-16.979,23.053c0,0.18,0.015,0.354,0.02,0.527c-8.016,4.25-13.415,12.271-13.415,21.479 c0,13.646,11.873,24.707,26.518,24.707c0.834,0,1.655-0.041,2.47-0.108c4.863,5.487,12.228,8.987,20.462,8.987 c13.534,0,24.691-9.451,26.312-21.655c8.418-4.144,14.158-12.371,14.158-21.854 C145.491,122.977,133.618,111.916,118.973,111.916z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.231,150.875c0,0,13.731,2.688,13.731,16.129c0,0,3.697,22.822-10.595,38.979h33 c-0.328-0.455-28.824-38.521,2.89-61.149C100.918,155.88,81.231,150.875,81.231,150.875z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.367,207.482h-36.33l2.206-2.494c13.663-15.445,10.273-37.523,10.238-37.744l-0.02-0.24 c0-10.928-10.095-14.05-12.181-14.577c-0.277-0.062-0.42-0.098-0.42-0.098l0.658-2.926c0,0,0.16,0.03,0.449,0.103 c1.106,0.241,5.026,1,10.458,1c6.787,0,16.995-1.21,27.088-6.976l1.615,2.523c-7.892,5.631-12.576,12.752-13.923,21.165 c-2.861,17.866,9.887,35.854,11.351,37.847l1.753,2.388L117.367,207.482z M87.529,204.482h26.991 c-3.932-6.047-12.823-21.845-10.278-37.738c0.989-6.177,3.597-11.705,7.779-16.518c-7.478,2.621-14.467,3.279-19.597,3.279 c-0.833,0-1.63-0.017-2.39-0.046c3.334,2.628,6.391,6.833,6.427,13.426C96.755,168.822,99.409,188.729,87.529,204.482z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.928,123.921",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.027,150.837c0,0-20.835,26.897-4.816,55.142h10.162 C117.369,205.979,96.225,176.428,112.027,150.837z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.159,161.646c0-12.345-10.74-22.353-23.988-22.353c-0.203,0-0.407,0.01-0.611,0.017 c-4.186-6.55-11.854-10.938-20.625-10.938c-13.248,0-23.981,10.008-23.981,22.353c0,0.162,0.012,0.315,0.014,0.479 c-7.244,3.85-12.135,11.104-12.135,19.432c0,12.347,10.732,22.353,23.981,22.353c0.753,0,1.497-0.039,2.23-0.103 c4.396,4.968,11.061,8.134,18.511,8.134c12.245,0,22.339-8.552,23.799-19.593C247.965,177.673,253.159,170.229,253.159,161.646 z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.555,202.52c-7.358,0-14.285-2.938-19.127-8.084c-0.56,0.035-1.093,0.053-1.614,0.053 c-14.051,0-25.481-10.7-25.481-23.853c0-8.272,4.622-15.974,12.125-20.31c0.228-12.969,11.569-23.454,25.478-23.454 c8.62,0,16.745,4.164,21.418,10.923c13.971,0.092,25.307,10.756,25.307,23.852c0,8.63-4.937,16.518-12.937,20.765 C239.782,193.93,229.111,202.52,216.555,202.52z M198.667,191.326l0.5,0.565c4.289,4.848,10.627,7.628,17.388,7.628 c11.341,0,20.933-7.862,22.312-18.289l0.105-0.795l0.719-0.354c7.383-3.641,11.969-10.705,11.969-18.435 c0-11.498-10.088-20.853-22.488-20.853c-0.138,0-0.276,0.006-0.414,0.011l-1.001,0.033l-0.46-0.72 c-4.039-6.32-11.458-10.246-19.361-10.246c-12.396,0-22.481,9.354-22.481,20.853l0.024,1.375l-0.807,0.429 c-6.994,3.717-11.339,10.655-11.339,18.107c0,11.498,10.085,20.853,22.481,20.853c0.66,0,1.348-0.031,2.102-0.097 L198.667,191.326z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.767,138.49c-0.206,0-0.409,0.014-0.614,0.018 c-3.354-5.25-8.944-9.109-15.558-10.438c5.229,1.312,9.633,4.492,12.339,8.729c0.175-0.004,2.579,4.146,2.757,4.146 c11.368,0,16.655,6.123,16.655,16.721c0,7.359-2.757,12.057-9.291,15.271c-1.252,9.474-9.915,16.812-20.423,16.812 c-6.396,0-12.106-2.723-15.884-6.979c-0.631,0.056-1.271,0.086-1.916,0.086c-11.368,0-20.299-5.39-20.299-15.979 c0-7.136,3.188-10.646,9.002-14.886c-0.156-0.918-0.808-8.985,1.353-11.141c5.116-5.117,7.438-9.516,12.011-11.785 c-8.979,3.229-15.354,11.347-15.354,20.854c0,0.158,0.012,0.314,0.016,0.479c-7.246,3.85-12.137,11.104-12.137,19.432 c0,12.344,10.738,22.354,23.988,22.354c0.754,0,1.496-0.035,2.229-0.104c4.401,4.967,11.063,8.133,18.509,8.133 c12.245,0,22.339-8.556,23.804-19.592c7.61-3.744,12.811-11.188,12.811-19.771C252.754,148.5,242.016,138.49,228.767,138.49z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.625,173.734c0,0,12.422,2.434,12.422,14.588c0,0,3.345,20.646-9.584,35.262h29.853 c-0.296-0.41-26.068-34.85,2.615-55.316C212.435,178.266,194.625,173.734,194.625,173.734z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.316,225.084h-33.182l2.206-2.494c12.288-13.892,9.258-33.829,9.227-34.029l-0.02-0.238 c0-9.772-9.036-12.571-10.909-13.045c-0.251-0.056-0.383-0.089-0.383-0.089l0.658-2.926c0,0,0.147,0.028,0.411,0.094 c0.999,0.218,4.532,0.902,9.431,0.902c6.121,0,15.329-1.092,24.432-6.294l1.615,2.523c-7.104,5.07-11.322,11.479-12.535,19.051 c-2.58,16.109,8.92,32.335,10.239,34.132l1.754,2.388L227.316,225.084z M200.609,222.084h23.868 c-3.632-5.64-11.452-19.78-9.172-34.02c0.872-5.443,3.125-10.332,6.725-14.609c-6.595,2.235-12.736,2.804-17.274,2.804 c-0.601,0-1.181-0.01-1.74-0.026c2.908,2.41,5.497,6.181,5.532,11.972C208.82,190.017,211.172,207.852,200.609,222.084z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.493,149.354",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.484,173.703c0,0-18.847,24.334-4.356,49.881h9.188 C227.315,223.583,208.188,196.852,222.484,173.703z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.893,159.796c0-13.11-11.408-23.737-25.479-23.737c-0.225,0-0.438,0.008-0.653,0.015 c-4.443-6.952-12.589-11.612-21.907-11.612c-14.066,0-25.479,10.629-25.479,23.735c0,0.171,0.011,0.336,0.015,0.509 C7.693,152.787,2.5,160.496,2.5,169.339c0,13.106,11.407,23.736,25.479,23.736c0.8,0,1.59-0.041,2.372-0.104 c4.674,5.271,11.745,8.639,19.659,8.639c13.007,0,23.729-9.081,25.279-20.809C83.378,176.818,88.893,168.912,88.893,159.796z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.01,203.109c-7.796,0-15.142-3.122-20.277-8.591c-0.62,0.038-1.198,0.057-1.754,0.057 C13.103,194.575,1,183.254,1,169.339c0-8.774,4.911-16.937,12.878-21.513c0.211-13.745,12.231-24.865,26.976-24.865 c9.145,0,17.762,4.424,22.702,11.598c14.812,0.072,26.837,11.365,26.837,25.237c0,9.149-5.242,17.507-13.734,21.99 C74.627,193.997,63.318,203.109,50.01,203.109z M30.976,191.415l0.497,0.561c4.583,5.169,11.339,8.134,18.537,8.134 c12.094,0,22.323-8.386,23.792-19.505l0.105-0.795l0.719-0.354c7.875-3.877,12.766-11.41,12.766-19.659 c0-12.262-10.757-22.237-23.979-22.237c-0.183,0-0.359,0.006-0.534,0.012l-0.853,0.027l-0.53-0.717 c-4.305-6.735-12.215-10.92-20.644-10.92c-13.222,0-23.979,9.975-23.979,22.235l0.035,1.4l-0.818,0.434 C8.634,153.986,4,161.385,4,169.339c0,12.261,10.757,22.236,23.979,22.236c0.689,0,1.425-0.032,2.251-0.1L30.976,191.415z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.985,135.203c-0.219,0-0.435,0.01-0.647,0.018 c-3.563-5.578-9.506-9.68-16.525-11.088c5.554,1.395,10.231,4.771,13.106,9.271c0.186-0.004,2.734,4.406,2.928,4.406 c12.076,0,17.692,6.506,17.692,17.758c0,7.82-2.934,12.806-9.87,16.222c-1.33,10.063-10.531,17.854-21.693,17.854 c-6.792,0-12.857-2.886-16.871-7.412c-0.67,0.058-1.348,0.092-2.035,0.092c-12.071,0-21.561-5.723-21.561-16.975 c0-7.574,3.391-11.311,9.561-15.811c-0.165-0.979-0.85-9.552,1.438-11.836c5.435-5.438,7.896-10.104,12.758-12.52 c-9.541,3.434-16.312,12.051-16.312,22.147c0,0.17,0.011,0.338,0.015,0.509c-7.696,4.084-12.89,11.791-12.89,20.637 c0,13.106,11.403,23.735,25.479,23.735c0.801,0,1.591-0.038,2.373-0.104c4.674,5.273,11.745,8.644,19.659,8.644 c13.006,0,23.728-9.082,25.273-20.813c8.094-3.979,13.604-11.891,13.604-21.002C88.466,145.83,77.058,135.203,62.985,135.203z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.723,172.635c0,0,13.193,2.584,13.193,15.495c0,0,3.553,21.933-10.184,37.451H61.44 c-0.312-0.438-27.689-37.017,2.777-58.761C45.638,177.445,26.723,172.635,26.723,172.635z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,227.081H26.402l2.208-2.494c13.086-14.784,9.86-36.006,9.826-36.219l-0.019-0.238 c0-10.453-9.662-13.442-11.659-13.947c-0.266-0.059-0.404-0.094-0.404-0.094l0.658-2.926c0,0,0.154,0.029,0.432,0.099 c1.061,0.231,4.818,0.959,10.028,0.959c6.515,0,16.313-1.162,26.001-6.702l1.616,2.522c-7.56,5.396-12.05,12.216-13.348,20.271 c-2.754,17.103,9.479,34.428,10.883,36.347l1.745,2.386L61.44,227.081z M32.889,224.081h25.712 c-3.807-5.892-12.268-21.056-9.822-36.245c0.944-5.862,3.402-11.115,7.334-15.7c-7.115,2.464-13.755,3.085-18.642,3.085 c-0.733,0-1.438-0.013-2.113-0.037c3.159,2.539,6.021,6.566,6.057,12.828C41.701,189.898,44.23,208.957,32.889,224.081z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.078,146.736",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.313,172.6c0,0-20.02,25.849-4.633,52.981h9.764 C61.443,225.583,41.129,197.189,56.313,172.6z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_3_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39
    },
    id: "Layer_4_5_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.913,110.333c0-39.901-32.429-72.247-72.422-72.247c-0.621,0-1.236,0.03-1.855,0.045 c-12.629-21.166-35.779-35.36-62.269-35.36c-39.998,0-72.424,32.348-72.424,72.25c0,0.519,0.029,1.028,0.04,1.546 c0,21.603-36.637,35.89-36.637,62.802c0,39.898,32.425,72.244,72.422,72.244c2.275,0,4.521-0.119,6.744-0.322 c29.338,0,33.382,26.285,55.88,26.285c36.974,0,67.442-27.639,71.854-63.328C221.429,149.339,249.913,138.072,249.913,110.333z",
    style: {
      fill: "#BDDBFF"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_4_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    id: "Layer_3_3_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.089,124.891c0-10.819-9.413-19.591-21.025-19.591c-0.181,0-0.356,0.007-0.539,0.013 c-3.666-5.741-10.389-9.587-18.078-9.587c-11.608,0-21.022,8.77-21.022,19.591c0,0.139,0.008,0.277,0.011,0.417 c-6.349,3.372-10.635,9.732-10.635,17.03c0,10.819,9.413,19.59,21.021,19.59c0.66,0,1.313-0.03,1.958-0.088 c3.857,4.354,9.693,7.129,16.226,7.129c10.73,0,19.581-7.496,20.857-17.172C80.538,138.939,85.089,132.412,85.089,124.891z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.005,160.895c-6.466,0-12.56-2.571-16.84-7.08c-0.45,0.026-0.899,0.039-1.344,0.039 c-12.418,0-22.521-9.461-22.521-21.09c0-7.285,4.049-14.067,10.629-17.908c0.263-11.417,10.263-20.63,22.517-20.63 c7.585,0,14.735,3.648,18.872,9.575c12.304,0.128,22.271,9.54,22.271,21.089c0,7.609-4.332,14.56-11.359,18.316 C73.477,153.346,64.07,160.895,53.005,160.895z M37.4,150.704l0.502,0.566c3.729,4.21,9.233,6.624,15.103,6.624 c9.85,0,18.177-6.821,19.37-15.868l0.105-0.796l0.72-0.354c6.408-3.151,10.389-9.277,10.389-15.986 c0-9.975-8.759-18.091-19.525-18.091c-0.13,0-0.258,0.004-0.388,0.009l-0.956,0.031l-0.459-0.72 c-3.503-5.486-9.946-8.894-16.814-8.894c-10.765,0-19.522,8.116-19.522,18.091l0.03,1.309l-0.815,0.433 c-6.068,3.224-9.838,9.241-9.838,15.705c0,9.975,8.757,18.09,19.521,18.09c0.603,0,1.216-0.027,1.824-0.082L37.4,150.704z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,104.595c-0.184,0-0.359,0.009-0.538,0.014 c-2.939-4.603-7.845-7.986-13.637-9.147c4.583,1.15,8.44,3.938,10.812,7.65c0.155-0.004,2.261,3.637,2.417,3.637 c9.964,0,14.603,5.369,14.603,14.653c0,6.453-2.417,10.565-8.146,13.383c-1.098,8.307-8.691,14.736-17.901,14.736 c-5.604,0-10.608-2.379-13.921-6.111c-0.554,0.047-1.109,0.07-1.68,0.07c-9.965,0-17.792-4.726-17.792-14.004 c0-6.257,2.798-9.334,7.891-13.043c-0.136-0.801-0.698-7.881,1.188-9.767c4.48-4.484,6.517-8.337,10.528-10.33 c-7.874,2.831-13.465,9.944-13.465,18.282c0,0.137,0.012,0.279,0.015,0.418c-6.354,3.372-10.64,9.728-10.64,17.026 c0,10.817,9.413,19.594,21.025,19.594c0.662,0,1.313-0.033,1.959-0.092c3.856,4.352,9.691,7.129,16.223,7.129 c10.732,0,19.581-7.498,20.86-17.176c6.675-3.281,11.229-9.812,11.229-17.332C84.736,113.368,75.323,104.595,63.71,104.595z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.785,135.488c0,0,10.888,2.131,10.888,12.785c0,0,2.931,18.1-8.399,30.905h26.165 c-0.259-0.362-22.854-30.553,2.292-48.489C49.395,139.458,33.785,135.488,33.785,135.488z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.439,180.679H32.944l2.207-2.494c10.708-12.103,8.07-29.498,8.042-29.673l-0.019-0.238 c0-8.424-7.795-10.842-9.418-11.253c-0.223-0.049-0.339-0.078-0.339-0.078l0.658-2.926c0,0,0.131,0.024,0.368,0.084 c0.874,0.189,3.949,0.784,8.214,0.784c5.345,0,13.384-0.954,21.331-5.497l1.616,2.522c-6.18,4.409-9.851,9.979-10.91,16.555 c-2.256,14.015,7.784,28.226,8.937,29.8l1.747,2.386L62.439,180.679z M39.397,177.679h20.22 c-3.266-5.15-9.866-17.4-7.886-29.69c0.738-4.586,2.587-8.723,5.519-12.371c-5.572,1.802-10.741,2.268-14.594,2.268 c-0.34,0-0.674-0.004-1-0.01c2.415,2.146,4.484,5.405,4.517,10.28C46.421,149.817,48.421,165.235,39.397,177.679z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.68,114.115",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.204,135.457c0,0-16.521,21.33-3.823,43.725h8.058 C62.438,179.18,45.674,155.75,58.204,135.457z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.023,123.691c0-10.132-8.812-18.346-19.688-18.346c-0.171,0-0.338,0.007-0.505,0.012 c-3.438-5.375-9.729-8.979-16.933-8.979c-10.874,0-19.688,8.214-19.688,18.346c0,0.131,0.009,0.262,0.011,0.391 c-5.945,3.158-9.96,9.112-9.96,15.948c0,10.129,8.816,18.348,19.689,18.348c0.613,0,1.228-0.029,1.834-0.082 c3.606,4.07,9.071,6.676,15.188,6.676c10.048,0,18.337-7.019,19.534-16.082C239.762,136.846,244.023,130.734,244.023,123.691z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.972,157.506c-6.062,0-11.777-2.406-15.802-6.628c-0.414,0.022-0.822,0.034-1.22,0.034 c-11.684,0-21.189-8.903-21.189-19.848c0-6.839,3.792-13.207,9.955-16.826c0.276-10.72,9.672-19.36,21.182-19.36 c7.226,0,13.788,3.337,17.727,8.969c11.551,0.145,20.898,8.991,20.898,19.844c0,7.146-4.061,13.675-10.65,17.216 C233.2,150.425,224.362,157.506,213.972,157.506z M199.406,147.771l0.501,0.564c3.475,3.922,8.601,6.171,14.064,6.171 c9.176,0,16.935-6.354,18.047-14.778l0.105-0.796l0.72-0.354c5.97-2.938,9.679-8.642,9.679-14.887 c0-9.289-8.159-16.846-18.188-16.846c-0.112,0-0.223,0.004-0.332,0.007l-0.979,0.029l-0.458-0.716 c-3.27-5.112-9.273-8.287-15.669-8.287c-10.028,0-18.188,7.557-18.188,16.846l0.024,1.286l-0.811,0.43 c-5.651,3.002-9.163,8.606-9.163,14.624c0,9.29,8.16,16.848,18.189,16.848c0.548,0,1.121-0.025,1.704-0.076L199.406,147.771z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.003,104.685c-0.173,0-0.335,0.008-0.505,0.012 c-2.751-4.312-7.353-7.479-12.771-8.565c4.291,1.076,7.906,3.687,10.127,7.163c0.146-0.003,2.117,3.405,2.268,3.405 c9.33,0,13.671,5.029,13.671,13.723c0,6.046-2.269,9.894-7.626,12.537c-1.028,7.774-8.144,13.795-16.768,13.795 c-5.247,0-9.938-2.229-13.039-5.726c-0.521,0.045-1.041,0.067-1.57,0.067c-9.334,0-16.662-4.427-16.662-13.116 c0-5.856,2.62-8.742,7.39-12.218c-0.13-0.755-0.656-7.38,1.11-9.145c4.193-4.2,6.104-7.807,9.854-9.672 c-7.373,2.649-12.604,9.312-12.604,17.117c0,0.13,0.005,0.256,0.011,0.392c-5.945,3.156-9.962,9.109-9.962,15.945 c0,10.129,8.815,18.347,19.688,18.347c0.618,0,1.229-0.031,1.837-0.084c3.607,4.075,9.072,6.676,15.188,6.676 c10.05,0,18.336-7.019,19.535-16.084c6.25-3.073,10.51-9.183,10.51-16.228C243.693,112.899,234.878,104.685,224.003,104.685z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.98,133.613c0,0,10.196,1.996,10.196,11.975c0,0,2.746,16.947-7.866,28.939h24.503 c-0.243-0.334-21.398-28.604,2.146-45.402C210.597,137.332,195.98,133.613,195.98,133.613z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.813,176.027H194.98l2.207-2.494c10.025-11.329,7.535-27.543,7.509-27.705l-0.02-0.24 c0-7.815-7.235-10.063-8.746-10.446c-0.211-0.047-0.32-0.074-0.32-0.074l0.658-2.926c0,0,0.125,0.023,0.349,0.079 c0.818,0.179,3.691,0.733,7.676,0.733c4.992,0,12.501-0.891,19.923-5.132l1.615,2.523c-5.777,4.122-9.203,9.33-10.183,15.479 c-2.131,13.372,7.932,27.215,8.361,27.798l1.761,2.39L222.813,176.027z M201.421,173.027h18.568 c-3.099-4.9-9.13-16.219-7.305-27.675c0.674-4.228,2.349-8.049,5.002-11.43c-5.114,1.61-9.848,2.031-13.395,2.031 c-0.233,0-0.463-0.002-0.689-0.006c2.195,2.025,4.041,5.054,4.073,9.522C207.912,147.062,209.755,161.39,201.421,173.027z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.438,113.601",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.847,133.585c0,0-15.47,19.976-3.578,40.94h7.546 C222.813,174.527,207.113,152.587,218.847,133.585z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.678,125.337c0-15.556-13.532-28.161-30.225-28.161c-0.265,0-0.521,0.011-0.774,0.018 c-5.271-8.251-14.935-13.784-25.987-13.784c-16.689,0-30.227,12.61-30.227,28.164c0,0.2,0.012,0.399,0.016,0.604 c-9.129,4.849-15.291,13.985-15.291,24.477c0,15.555,13.535,28.166,30.229,28.166c0.948,0,1.888-0.049,2.812-0.131 c5.545,6.26,13.937,10.248,23.32,10.248c15.431,0,28.15-10.773,29.99-24.687C203.136,145.535,209.678,136.15,209.678,125.337z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.552,176.438c-9.219,0-17.897-3.707-23.936-10.195c-0.76,0.053-1.483,0.078-2.197,0.078 c-17.496,0-31.729-13.309-31.729-29.666c0-10.351,5.83-19.986,15.277-25.356c0.159-16.23,14.33-29.388,31.725-29.388 c10.808,0,20.987,5.253,26.782,13.766c17.483,0.011,31.704,13.313,31.704,29.661c0,10.8-6.211,20.654-16.265,25.9 C192.585,165.659,179.252,176.438,163.552,176.438z M140.853,163.129l0.502,0.566c5.484,6.191,13.575,9.742,22.197,9.742 c14.486,0,26.74-10.053,28.503-23.383l0.105-0.796l0.72-0.354c9.437-4.639,15.298-13.669,15.298-23.568 c0-14.701-12.886-26.661-28.725-26.661c-0.177,0-0.35,0.006-0.521,0.011l-1.062,0.029l-0.456-0.715 c-5.158-8.075-14.632-13.091-24.724-13.091c-15.84,0-28.727,11.961-28.727,26.664c0,0.101,0.004,0.203,0.007,0.305l0.025,1.191 l-0.813,0.432c-8.94,4.749-14.495,13.621-14.495,23.152c0,14.704,12.888,26.666,28.729,26.666c0.855,0,1.731-0.041,2.68-0.125 L140.853,163.129z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.945,96.162c-0.259,0-0.517,0.011-0.771,0.019 c-4.229-6.617-11.276-11.482-19.604-13.15c6.593,1.652,12.142,5.66,15.55,10.997c0.224-0.005,3.252,5.228,3.476,5.228 c14.325,0,20.988,7.718,20.988,21.064c0,9.276-3.479,15.188-11.709,19.242c-1.578,11.936-12.495,21.182-25.734,21.182 c-8.058,0-15.255-3.422-20.013-8.793c-0.797,0.068-1.604,0.107-2.415,0.107c-14.326,0-25.577-6.787-25.577-20.138 c0-8.985,4.021-13.414,11.341-18.751c-0.194-1.155-1.008-11.327,1.703-14.04c6.447-6.447,9.368-11.985,15.136-14.849 c-11.315,4.07-19.352,14.296-19.352,26.276c0,0.201,0.011,0.4,0.017,0.605c-9.129,4.846-15.291,13.984-15.291,24.479 c0,15.555,13.533,28.163,30.229,28.163c0.951,0,1.888-0.046,2.812-0.127c5.544,6.261,13.938,10.244,23.321,10.244 c15.429,0,28.146-10.772,29.988-24.687c9.596-4.721,16.137-14.104,16.137-24.911C209.171,108.769,195.639,96.162,178.945,96.162 z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.926,140.568c0,0,15.652,3.062,15.652,18.385c0,0,4.215,26.021-12.076,44.43h37.614 c-0.372-0.52-32.854-43.908,3.296-69.699C158.365,146.279,135.926,140.568,135.926,140.568z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.116,204.883h-40.944l2.207-2.494c15.639-17.672,11.76-42.942,11.719-43.195l-0.02-0.24 c0-12.614-11.645-16.214-14.042-16.819c-0.316-0.069-0.48-0.111-0.48-0.111l0.658-2.926c0,0,0.182,0.034,0.509,0.116 c1.263,0.275,5.755,1.147,11.973,1.147c7.758,0,19.43-1.385,30.973-7.979l1.615,2.523 c-9.037,6.447-14.404,14.604-15.953,24.241c-3.282,20.417,11.295,41.029,12.968,43.312l1.749,2.387L177.116,204.883z  M142.683,201.883h31.579c-4.349-6.621-14.839-24.894-11.895-43.213c1.166-7.254,4.303-13.718,9.356-19.311 c-8.783,3.207-17.026,4.001-23.028,4.001c-1.196,0-2.329-0.03-3.391-0.082c3.961,2.935,7.734,7.771,7.773,15.557 C153.4,160.947,156.501,183.904,142.683,201.883z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.838,109.846",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.029,140.527c0,0-23.744,30.662-5.492,62.852h11.583 C177.116,203.378,153.017,169.697,171.029,140.527z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.454,126.378c0-12.77-11.11-23.122-24.815-23.122c-0.213,0-0.424,0.01-0.636,0.016 c-4.326-6.774-12.26-11.315-21.336-11.315c-13.704,0-24.815,10.352-24.815,23.12c0,0.167,0.011,0.331,0.018,0.495 c-7.496,3.979-12.557,11.482-12.557,20.099c0,12.771,11.109,23.121,24.815,23.121c0.779,0,1.549-0.039,2.311-0.101 c4.556,5.134,11.438,8.408,19.146,8.408c12.668,0,23.106-8.848,24.62-20.266C137.082,142.958,142.454,135.255,142.454,126.378z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.585,168.6c-7.596,0-14.755-3.038-19.764-8.361c-0.594,0.036-1.153,0.054-1.693,0.054 c-14.51,0-26.315-11.045-26.315-24.621c0-8.549,4.782-16.505,12.542-20.975c0.219-13.4,11.938-24.239,26.312-24.239 c8.913,0,17.311,4.309,22.13,11.299c14.438,0.081,26.157,11.095,26.157,24.622c0,8.921-5.106,17.068-13.38,21.441 C128.579,159.722,117.554,168.6,104.585,168.6z M86.064,157.136l0.497,0.561c4.457,5.022,11.027,7.903,18.024,7.903 c11.755,0,21.7-8.152,23.133-18.963l0.105-0.795l0.72-0.354c7.655-3.768,12.411-11.09,12.411-19.11 c0-11.922-10.459-21.622-23.315-21.622c-0.132,0-0.263,0.005-0.395,0.009l-1.048,0.03l-0.457-0.716 c-4.185-6.552-11.875-10.622-20.072-10.622c-12.856,0-23.315,9.699-23.315,21.62c0,0.099,0.005,0.196,0.01,0.293l0.046,1.083 l-0.835,0.443c-7.253,3.85-11.76,11.043-11.76,18.774c0,11.922,10.459,21.621,23.315,21.621c0.676,0,1.393-0.031,2.19-0.096 L86.064,157.136z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.223,102.426c-0.215,0-0.424,0.008-0.637,0.014 c-3.469-5.432-9.258-9.425-16.094-10.796c5.405,1.357,9.964,4.648,12.766,9.028c0.181-0.005,2.667,4.292,2.852,4.292 c11.764,0,17.231,6.336,17.231,17.293c0,7.617-2.854,12.472-9.61,15.798c-1.295,9.799-10.258,17.392-21.127,17.392 c-6.616,0-12.521-2.812-16.432-7.22c-0.653,0.059-1.314,0.09-1.982,0.09c-11.761,0-20.997-5.572-20.997-16.527 c0-7.379,3.305-11.018,9.313-15.396c-0.16-0.948-0.827-9.299,1.396-11.524c5.292-5.293,7.69-9.84,12.428-12.191 c-9.292,3.341-15.892,11.735-15.892,21.572c0,0.166,0.011,0.33,0.018,0.495c-7.497,3.977-12.558,11.479-12.558,20.098 c0,12.771,11.11,23.118,24.815,23.118c0.78,0,1.548-0.037,2.31-0.104c4.556,5.139,11.439,8.41,19.147,8.41 c12.667,0,23.104-8.845,24.621-20.267c7.878-3.873,13.25-11.575,13.25-20.448C142.037,112.778,130.927,102.426,117.223,102.426z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.904,138.882c0,0,12.854,2.517,12.854,15.093c0,0,3.46,21.358-9.915,36.479h30.88 c-0.307-0.428-26.973-36.051,2.705-57.229C100.327,143.57,81.904,138.882,81.904,138.882z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.722,191.953H81.512l2.206-2.494c12.729-14.391,9.591-35.039,9.558-35.246l-0.019-0.238 c0-10.149-9.383-13.055-11.326-13.547c-0.262-0.058-0.397-0.092-0.397-0.092l0.658-2.926c0,0,0.152,0.029,0.426,0.097 c1.034,0.226,4.694,0.935,9.765,0.935c6.339,0,15.874-1.131,25.3-6.52l1.615,2.523c-7.359,5.252-11.729,11.891-12.988,19.731 c-2.676,16.659,9.232,33.494,10.599,35.358l1.75,2.387L115.722,191.953z M87.993,188.953h24.89 c-3.731-5.78-11.907-20.487-9.535-35.252c0.912-5.677,3.279-10.769,7.064-15.218c-6.882,2.36-13.299,2.958-18.029,2.958 c-0.675,0-1.325-0.012-1.949-0.032c3.048,2.482,5.788,6.395,5.823,12.447C96.536,155.71,98.986,174.224,87.993,188.953z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.042,113.661",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.723,138.85c0,0-19.497,25.172-4.511,51.604h9.509 C115.722,190.451,95.935,162.796,110.723,138.85z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.792,148.964c0-11.553-10.051-20.913-22.448-20.913c-0.188,0-0.379,0.008-0.57,0.014 c-3.919-6.129-11.092-10.233-19.301-10.233c-12.396,0-22.444,9.36-22.444,20.915c0,0.146,0.015,0.297,0.017,0.445 c-6.778,3.604-11.355,10.395-11.355,18.186c0,11.561,10.046,20.92,22.444,20.92c0.705,0,1.401-0.033,2.086-0.101 c4.117,4.651,10.353,7.614,17.323,7.614c11.459,0,20.901-8.006,22.271-18.336C237.932,163.962,242.792,156.998,242.792,148.964 z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.543,187.311c-6.893,0-13.384-2.746-17.935-7.561c-0.486,0.031-0.979,0.047-1.475,0.047 c-13.203,0-23.944-10.058-23.944-22.42c0-7.755,4.323-14.979,11.343-19.061c0.245-12.162,10.891-21.985,23.94-21.985 c8.206,0,15.653,3.805,20.096,10.221c13.102,0.113,23.724,10.124,23.724,22.412c0,8.097-4.62,15.498-12.111,19.494 C230.334,179.261,220.32,187.311,208.543,187.311z M191.835,176.629l0.508,0.573c3.999,4.518,9.903,7.108,16.2,7.108 c10.562,0,19.496-7.322,20.783-17.033l0.105-0.794l0.718-0.354c6.873-3.392,11.143-9.97,11.143-17.166 c0-10.704-9.397-19.413-20.948-19.413c-0.134,0-0.27,0.005-0.405,0.009l-0.97,0.03l-0.459-0.718 c-3.764-5.885-10.675-9.541-18.037-9.541c-11.549,0-20.944,8.71-20.944,19.415l0.006,0.158c0.005,0.089,0.01,0.179,0.011,0.268 l0.012,0.914l-0.808,0.43c-6.514,3.464-10.56,9.925-10.56,16.861c0,10.708,9.396,19.42,20.944,19.42 c0.657,0,1.31-0.031,1.939-0.094L191.835,176.629z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.967,127.296c-0.193,0-0.383,0.009-0.575,0.015 c-3.139-4.914-8.375-8.523-14.559-9.768c4.894,1.229,9.015,4.203,11.547,8.166c0.163-0.004,2.413,3.885,2.579,3.885 c10.639,0,15.586,5.729,15.586,15.646c0,6.893-2.579,11.278-8.694,14.291c-1.172,8.862-9.277,15.731-19.107,15.731 c-5.985,0-11.329-2.545-14.864-6.531c-0.59,0.055-1.189,0.082-1.793,0.082c-10.642,0-18.995-5.043-18.995-14.953 c0-6.678,2.979-9.963,8.424-13.93c-0.146-0.858-0.753-8.41,1.267-10.426c4.787-4.789,6.956-8.904,11.238-11.028 c-8.4,3.021-14.371,10.616-14.371,19.514c0,0.147,0.017,0.298,0.021,0.449c-6.78,3.599-11.359,10.392-11.359,18.181 c0,11.551,10.049,20.916,22.448,20.916c0.705,0,1.396-0.031,2.088-0.097c4.119,4.646,10.35,7.609,17.32,7.609 c11.459,0,20.9-8.004,22.271-18.334c7.127-3.502,11.99-10.473,11.99-18.502C242.413,136.66,232.365,127.296,219.967,127.296z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M188.017,160.277c0,0,11.625,2.271,11.625,13.649c0,0,3.13,19.318-8.969,32.992h27.936 c-0.273-0.383-24.396-32.604,2.447-51.767C204.683,164.518,188.017,160.277,188.017,160.277z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.609,208.419h-31.266l2.207-2.494c11.494-12.991,8.642-31.572,8.611-31.758l-0.02-0.24 c0-9.069-8.387-11.669-10.129-12.11c-0.241-0.054-0.366-0.085-0.366-0.085l0.657-2.927c0,0,0.142,0.027,0.395,0.091 c0.935,0.203,4.228,0.84,8.789,0.84c5.719,0,14.32-1.021,22.823-5.885l1.616,2.522c-6.622,4.728-10.554,10.7-11.688,17.752 c-2.412,15.002,8.325,30.194,9.558,31.878l1.747,2.386L218.609,208.419z M193.808,205.419h21.972 c-3.442-5.391-10.627-18.558-8.502-31.771c0.803-4.993,2.843-9.488,6.091-13.438c-6.063,2.01-11.698,2.525-15.881,2.525 c-0.461,0-0.909-0.007-1.345-0.018c2.65,2.274,4.965,5.779,4.999,11.091C201.402,175.545,203.569,192.119,193.808,205.419z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.379,137.46",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.088,160.246c0,0-17.637,22.771-4.082,46.678h8.603 C218.608,206.921,200.71,181.91,214.088,160.246z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.074,147.232c0-12.271-10.68-22.213-23.847-22.213c-0.206,0-0.404,0.006-0.607,0.012 c-4.158-6.508-11.781-10.866-20.5-10.866c-13.167,0-23.848,9.944-23.848,22.211c0,0.158,0.014,0.313,0.018,0.474 c-7.201,3.823-12.063,11.039-12.063,19.315c0,12.267,10.675,22.213,23.843,22.213c0.749,0,1.488-0.039,2.224-0.099 c4.374,4.935,10.991,8.084,18.396,8.084c12.172,0,22.206-8.5,23.656-19.476C83.913,163.164,89.074,155.762,89.074,147.232z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.689,187.863c-7.307,0-14.192-2.92-19.013-8.036c-0.57,0.034-1.1,0.051-1.606,0.051 c-13.974,0-25.343-10.638-25.343-23.713c0-8.226,4.594-15.882,12.049-20.191c0.23-12.89,11.511-23.309,25.344-23.309 c8.574,0,16.653,4.139,21.296,10.855c13.889,0.095,25.158,10.695,25.158,23.712c0,8.585-4.907,16.426-12.861,20.641 C75.783,179.324,65.172,187.863,52.689,187.863z M34.919,176.724l0.497,0.561c4.27,4.816,10.565,7.579,17.273,7.579 c11.27,0,20.8-7.812,22.169-18.172l0.105-0.796l0.72-0.354c7.335-3.609,11.892-10.625,11.892-18.31 c0-11.421-10.025-20.713-22.347-20.713c-0.187,0-0.367,0.006-0.55,0.011l-0.85,0.024l-0.472-0.716 c-4.009-6.275-11.38-10.174-19.236-10.174c-12.323,0-22.348,9.291-22.348,20.711c0,0.066,0.004,0.132,0.007,0.198l0.032,1.166 l-0.818,0.435c-6.95,3.689-11.267,10.583-11.267,17.99c0,11.421,10.023,20.713,22.343,20.713c0.636,0,1.324-0.03,2.103-0.094 L34.919,176.724z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.831,124.219c-0.205,0-0.407,0.008-0.61,0.012 c-3.333-5.215-8.896-9.057-15.464-10.373c5.196,1.304,9.574,4.466,12.264,8.675c0.174-0.004,2.563,4.123,2.74,4.123 c11.3,0,16.556,6.09,16.556,16.617c0,7.315-2.737,11.979-9.232,15.18c-1.245,9.42-9.855,16.709-20.303,16.709 c-6.354,0-12.03-2.701-15.785-6.936c-0.627,0.053-1.266,0.086-1.905,0.086c-11.3,0-20.176-5.355-20.176-15.886 c0-7.09,3.173-10.584,8.943-14.793c-0.15-0.911-0.795-8.938,1.349-11.075c5.086-5.084,7.389-9.455,11.938-11.71 c-8.929,3.209-15.266,11.276-15.266,20.722c0,0.158,0.009,0.315,0.013,0.477c-7.202,3.82-12.061,11.035-12.061,19.314 c0,12.264,10.674,22.209,23.843,22.209c0.75,0,1.489-0.035,2.221-0.096c4.374,4.932,10.991,8.084,18.396,8.084 c12.171,0,22.205-8.5,23.651-19.476c7.569-3.728,12.73-11.129,12.73-19.651C88.674,134.164,77.999,124.219,64.831,124.219z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.896,159.25c0,0,12.35,2.416,12.35,14.5c0,0,3.321,20.523-9.525,35.045h29.67 c-0.294-0.406-25.917-34.639,2.598-54.984C48.596,163.75,30.896,159.25,30.896,159.25z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.39,210.295h-33l2.206-2.494c12.208-13.799,9.2-33.614,9.168-33.812l-0.019-0.238 c0-9.708-8.978-12.487-10.838-12.958c-0.251-0.055-0.381-0.088-0.381-0.088l0.658-2.926c0,0,0.146,0.027,0.41,0.094 c0.992,0.216,4.499,0.895,9.36,0.895c6.085,0,15.239-1.086,24.289-6.259l1.615,2.523c-7.063,5.04-11.255,11.412-12.458,18.938 c-2.562,16.02,8.869,32.129,10.181,33.913l1.756,2.389L63.39,210.295z M36.865,207.295h23.686 c-3.617-5.614-11.375-19.648-9.112-33.799c0.864-5.405,3.098-10.26,6.666-14.509c-6.547,2.215-12.644,2.779-17.15,2.779 c-0.583,0-1.149-0.01-1.693-0.026c2.885,2.398,5.449,6.145,5.483,11.892C45.016,175.438,47.347,193.155,36.865,207.295z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.714,135.012",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.585,159.214c0,0-18.734,24.188-4.335,49.578h9.137 C63.388,208.792,44.376,182.227,58.585,159.214z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    id: "Layer_3_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.025,124.891c0-10.819-9.413-19.591-21.021-19.591c-0.186,0-0.36,0.007-0.539,0.013 c-3.666-5.741-10.389-9.587-18.078-9.587c-11.612,0-21.026,8.77-21.026,19.591c0,0.139,0.012,0.277,0.015,0.417 c-6.353,3.372-10.639,9.732-10.639,17.03c0,10.819,9.413,19.59,21.025,19.59c0.66,0,1.313-0.03,1.958-0.088 c3.857,4.354,9.693,7.129,16.222,7.129c10.734,0,19.582-7.496,20.862-17.172C81.474,138.939,86.025,132.412,86.025,124.891z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.942,160.895c-6.464,0-12.556-2.571-16.836-7.08c-13.019,0.763-23.869-9.006-23.869-21.051 c0-7.284,4.049-14.066,10.629-17.906c0.262-11.418,10.264-20.632,22.521-20.632c7.585,0,14.735,3.648,18.872,9.575 c12.301,0.128,22.266,9.54,22.266,21.089c0,7.608-4.33,14.559-11.354,18.316C74.414,153.345,65.005,160.895,53.942,160.895z  M38.341,150.704l0.502,0.566c3.729,4.21,9.232,6.624,15.099,6.624c9.849,0,18.178-6.822,19.375-15.868l0.105-0.795 l0.719-0.354c6.405-3.152,10.383-9.278,10.383-15.986c0-9.975-8.757-18.091-19.521-18.091c-0.136,0-0.266,0.005-0.396,0.009 l-0.855,0.029l-0.552-0.718c-3.503-5.486-9.946-8.894-16.814-8.894c-10.767,0-19.526,8.116-19.526,18.091l0.034,1.309 l-0.816,0.433c-6.071,3.223-9.842,9.24-9.842,15.705c0,9.975,8.759,18.09,19.525,18.09c0.603,0,1.216-0.027,1.824-0.082 L38.341,150.704z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.646,104.595c-0.181,0-0.355,0.009-0.539,0.014 c-2.938-4.603-7.844-7.986-13.637-9.147c4.583,1.15,8.443,3.938,10.816,7.65c0.15-0.004,2.261,3.637,2.417,3.637 c9.964,0,14.6,5.369,14.6,14.653c0,6.453-2.417,10.565-8.146,13.383c-1.102,8.307-8.691,14.736-17.9,14.736 c-5.606,0-10.612-2.379-13.922-6.111c-0.553,0.047-1.113,0.07-1.683,0.07c-9.965,0-17.792-4.726-17.792-14.004 c0-6.257,2.802-9.334,7.895-13.043c-0.136-0.801-0.702-7.881,1.186-9.767c4.484-4.484,6.52-8.337,10.527-10.33 c-7.874,2.831-13.461,9.944-13.461,18.282c0,0.137,0.008,0.279,0.011,0.418c-6.351,3.372-10.636,9.728-10.636,17.026 c0,10.817,9.413,19.594,21.025,19.594c0.658,0,1.312-0.033,1.958-0.092c3.854,4.352,9.688,7.129,16.223,7.129 c10.729,0,19.58-7.498,20.855-17.176c6.679-3.281,11.229-9.81,11.229-17.332C85.672,113.368,76.259,104.595,64.646,104.595z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.721,135.488c0,0,10.888,2.131,10.888,12.785c0,0,2.935,18.1-8.396,30.905h26.165 c-0.259-0.362-22.854-30.551,2.292-48.489C50.33,139.458,34.721,135.488,34.721,135.488z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.377,180.679H33.882l2.207-2.494c10.709-12.103,8.067-29.498,8.039-29.673l-0.019-0.238 c0-8.424-7.795-10.841-9.418-11.253c-0.223-0.049-0.339-0.078-0.339-0.078l0.658-2.926c0,0,0.131,0.024,0.368,0.084 c0.874,0.189,3.949,0.784,8.214,0.784c5.345,0,13.385-0.954,21.333-5.497l1.616,2.522c-6.181,4.409-9.852,9.979-10.911,16.557 c-2.256,14.014,7.785,28.224,8.937,29.798l1.747,2.386L63.377,180.679z M40.335,177.679h20.22 c-3.266-5.15-9.866-17.398-7.887-29.688c0.739-4.586,2.588-8.725,5.521-12.373c-5.574,1.802-10.743,2.268-14.598,2.268 c-0.341,0-0.674-0.004-1-0.01c2.415,2.146,4.484,5.405,4.517,10.28C47.357,149.819,49.359,165.236,40.335,177.679z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.615,114.115",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,135.457c0,0-16.521,21.33-3.822,43.725h8.062 C63.374,179.18,46.609,155.75,59.14,135.457z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.96,123.691c0-10.132-8.815-18.346-19.689-18.346c-0.171,0-0.337,0.007-0.505,0.012 c-3.433-5.375-9.728-8.979-16.929-8.979c-10.874,0-19.69,8.214-19.69,18.346c0,0.131,0.013,0.262,0.016,0.391 c-5.946,3.158-9.961,9.112-9.961,15.948c0,10.129,8.812,18.348,19.688,18.348c0.618,0,1.229-0.029,1.834-0.082 c3.61,4.07,9.075,6.676,15.191,6.676c10.049,0,18.337-7.019,19.53-16.082C240.698,136.846,244.96,130.734,244.96,123.691z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.914,157.506c-6.061,0-11.777-2.407-15.806-6.628c-0.413,0.022-0.821,0.034-1.22,0.034 c-11.683,0-21.188-8.903-21.188-19.848c0-6.837,3.79-13.204,9.951-16.823c0.275-10.721,9.673-19.363,21.185-19.363 c7.116,0,13.826,3.417,17.722,8.969c11.552,0.145,20.901,8.991,20.901,19.844c0,7.145-4.06,13.673-10.649,17.216 C234.144,150.425,225.306,157.506,214.914,157.506z M200.344,147.771l0.501,0.564c3.479,3.922,8.606,6.171,14.069,6.171 c9.177,0,16.934-6.354,18.043-14.778l0.104-0.795l0.721-0.354c5.97-2.938,9.678-8.643,9.678-14.887 c0-9.289-8.16-16.846-18.189-16.846c-0.111,0-0.221,0.004-0.33,0.007l-0.981,0.029l-0.458-0.717 c-3.264-5.111-9.266-8.286-15.664-8.286c-10.03,0-18.19,7.557-18.19,16.846l0.036,1.282l-0.817,0.434 c-5.652,3.002-9.164,8.605-9.164,14.624c0,9.29,8.159,16.848,18.188,16.848c0.55,0,1.123-0.025,1.704-0.076L200.344,147.771z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.938,104.685c-0.172,0-0.335,0.008-0.504,0.012 c-2.752-4.312-7.349-7.479-12.771-8.565c4.291,1.076,7.902,3.687,10.127,7.163c0.145-0.003,2.118,3.405,2.264,3.405 c9.331,0,13.671,5.029,13.671,13.723c0,6.046-2.265,9.894-7.625,12.537c-1.029,7.774-8.14,13.795-16.765,13.795 c-5.247,0-9.938-2.229-13.038-5.726c-0.521,0.045-1.041,0.067-1.574,0.067c-9.334,0-16.662-4.427-16.662-13.116 c0-5.854,2.62-8.738,7.393-12.218c-0.133-0.753-0.656-7.378,1.108-9.143c4.197-4.2,6.104-7.808,9.857-9.674 c-7.373,2.652-12.605,9.312-12.605,17.117c0,0.13,0.005,0.258,0.015,0.392c-5.946,3.156-9.965,9.111-9.965,15.945 c0,10.131,8.814,18.347,19.688,18.347c0.619,0,1.229-0.028,1.834-0.082c3.611,4.075,9.076,6.674,15.191,6.674 c10.05,0,18.336-7.019,19.531-16.082c6.25-3.073,10.514-9.185,10.514-16.229C244.629,112.899,235.813,104.685,224.938,104.685z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.916,133.613c0,0,10.193,1.996,10.193,11.975c0,0,2.745,16.947-7.863,28.939h24.503 c-0.243-0.334-21.401-28.604,2.146-45.402C211.532,137.332,196.916,133.613,196.916,133.613z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.749,176.027h-27.833l2.207-2.494c10.021-11.329,7.532-27.543,7.506-27.705l-0.02-0.24 c0-7.816-7.234-10.063-8.744-10.446c-0.21-0.047-0.319-0.074-0.319-0.074l0.658-2.926c0,0,0.124,0.023,0.348,0.079 c0.819,0.178,3.691,0.733,7.677,0.733c4.992,0,12.5-0.891,19.922-5.132l1.615,2.523c-5.777,4.122-9.204,9.33-10.184,15.479 c-2.131,13.371,7.934,27.215,8.363,27.798l1.761,2.39L223.749,176.027z M202.357,173.027h18.568 c-3.098-4.901-9.131-16.22-7.306-27.676c0.674-4.227,2.349-8.048,5.003-11.429c-5.452,1.717-10.432,2.088-14.085,2.025 c2.194,2.024,4.04,5.054,4.072,9.522C208.846,147.062,210.689,161.39,202.357,173.027z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M203.373,113.601",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.783,133.585c0,0-15.475,19.976-3.579,40.94h7.546 C223.748,174.527,208.049,152.587,219.783,133.585z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.615,125.337c0-15.556-13.529-28.161-30.227-28.161c-0.26,0-0.518,0.011-0.773,0.018 c-5.271-8.251-14.936-13.784-25.984-13.784c-16.692,0-30.229,12.61-30.229,28.164c0,0.2,0.016,0.399,0.02,0.604 c-9.129,4.849-15.29,13.985-15.29,24.477c0,15.555,13.534,28.166,30.227,28.166c0.948,0,1.892-0.049,2.814-0.131 c5.546,6.26,13.933,10.248,23.317,10.248c15.434,0,28.149-10.773,29.989-24.687 C204.071,145.535,210.615,136.15,210.615,125.337z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.489,176.438c-9.217,0-17.895-3.706-23.934-10.195c-0.757,0.052-1.494,0.078-2.198,0.078 c-17.494,0-31.727-13.309-31.727-29.666c0-10.35,5.828-19.983,15.272-25.354c0.157-16.232,14.33-29.391,31.728-29.391 c10.805,0,20.983,5.253,26.779,13.766c17.484,0.011,31.705,13.313,31.705,29.661c0,10.799-6.211,20.654-16.266,25.9 C193.521,165.659,180.188,176.438,164.489,176.438z M141.792,163.128l0.502,0.566c5.485,6.192,13.575,9.743,22.194,9.743 c14.486,0,26.739-10.053,28.502-23.383l0.105-0.796l0.72-0.354c9.437-4.64,15.299-13.67,15.299-23.568 c0-14.701-12.887-26.661-28.727-26.661c-0.172,0-0.343,0.006-0.513,0.011l-1.068,0.029l-0.456-0.714 c-5.159-8.075-14.632-13.091-24.721-13.091c-15.842,0-28.729,11.961-28.729,26.664c0,0.091,0.004,0.182,0.009,0.274 l0.028,1.222l-0.814,0.432c-8.94,4.749-14.494,13.62-14.494,23.152c0,14.704,12.887,26.666,28.727,26.666 c0.847,0,1.749-0.042,2.682-0.125L141.792,163.128z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.881,96.162c-0.259,0-0.521,0.011-0.773,0.019 c-4.227-6.617-11.273-11.482-19.604-13.15c6.589,1.652,12.138,5.66,15.548,10.997c0.222-0.005,3.25,5.228,3.474,5.228 c14.325,0,20.989,7.718,20.989,21.064c0,9.276-3.477,15.188-11.71,19.242c-1.578,11.936-12.495,21.182-25.733,21.182 c-8.058,0-15.256-3.422-20.014-8.793c-0.796,0.068-1.601,0.107-2.415,0.107c-14.326,0-25.577-6.787-25.577-20.138 c0-8.985,4.022-13.414,11.345-18.751c-0.195-1.155-1.012-11.327,1.7-14.04c6.447-6.447,9.368-11.985,15.139-14.849 c-11.318,4.07-19.354,14.296-19.354,26.276c0,0.201,0.012,0.4,0.021,0.605c-9.129,4.846-15.291,13.984-15.291,24.479 c0,15.555,13.529,28.163,30.226,28.163c0.951,0,1.887-0.046,2.814-0.127c5.544,6.261,13.934,10.244,23.317,10.244 c15.433,0,28.147-10.772,29.988-24.687c9.596-4.721,16.137-14.104,16.137-24.911C210.106,108.769,196.574,96.162,179.881,96.162 z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.861,140.568c0,0,15.652,3.062,15.652,18.385c0,0,4.215,26.02-12.076,44.43h37.615 c-0.373-0.52-32.854-43.908,3.295-69.699C159.301,146.279,136.861,140.568,136.861,140.568z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.052,204.883h-40.945l2.207-2.494c15.611-17.643,11.759-42.943,11.719-43.196l-0.02-0.239 c0-12.614-11.646-16.214-14.042-16.819c-0.315-0.069-0.48-0.111-0.48-0.111l0.658-2.926c0,0,0.182,0.034,0.509,0.116 c1.263,0.275,5.754,1.147,11.973,1.147c7.759,0,19.431-1.385,30.973-7.979l1.615,2.523 c-9.038,6.449-14.406,14.607-15.954,24.248c-3.279,20.43,11.298,41.025,12.971,43.307l1.751,2.388L178.052,204.883z  M143.617,201.883h31.578c-4.348-6.618-14.835-24.878-11.894-43.205c1.165-7.258,4.302-13.725,9.356-19.318 c-8.783,3.207-17.026,4.001-23.028,4.001c-1.195,0-2.329-0.03-3.391-0.082c3.961,2.935,7.734,7.771,7.773,15.557 C154.334,160.947,157.436,183.902,143.617,201.883z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.773,109.846",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.965,140.527c0,0-23.748,30.662-5.496,62.852h11.584 C178.053,203.378,153.952,169.697,171.965,140.527z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.39,126.378c0-12.77-11.11-23.122-24.812-23.122c-0.217,0-0.428,0.01-0.639,0.016 c-4.327-6.774-12.261-11.315-21.336-11.315c-13.704,0-24.812,10.352-24.812,23.12c0,0.167,0.012,0.331,0.014,0.495 c-7.496,3.979-12.553,11.482-12.553,20.099c0,12.771,11.106,23.121,24.812,23.121c0.778,0,1.549-0.039,2.313-0.103 c4.552,5.136,11.438,8.41,19.146,8.41c12.668,0,23.109-8.848,24.619-20.268C138.019,142.958,143.39,135.255,143.39,126.378z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.523,168.6c-7.6,0-14.758-3.038-19.763-8.361c-0.591,0.036-1.151,0.054-1.696,0.054 c-14.509,0-26.312-11.045-26.312-24.621c0-8.552,4.782-16.509,12.542-20.977c0.221-13.399,11.938-24.237,26.31-24.237 c8.912,0,17.309,4.309,22.13,11.299c14.438,0.078,26.157,11.093,26.157,24.622c0,8.922-5.105,17.068-13.379,21.439 C129.52,159.721,118.495,168.6,105.523,168.6z M87.002,157.133l0.498,0.562c4.453,5.024,11.021,7.905,18.023,7.905 c11.758,0,21.703-8.152,23.132-18.964l0.105-0.796l0.72-0.354c7.655-3.765,12.41-11.087,12.41-19.108 c0-11.922-10.458-21.622-23.312-21.622c-0.135,0-0.269,0.005-0.4,0.009l-1.045,0.03l-0.457-0.715 c-4.186-6.552-11.876-10.623-20.072-10.623c-12.854,0-23.312,9.699-23.312,21.62l0.024,1.392l-0.808,0.428 c-7.251,3.849-11.756,11.042-11.756,18.774c0,11.922,10.458,21.621,23.312,21.621c0.684,0,1.4-0.032,2.189-0.098 L87.002,157.133z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.158,102.426c-0.218,0-0.428,0.008-0.641,0.014 c-3.468-5.432-9.258-9.425-16.093-10.796c5.409,1.357,9.964,4.648,12.766,9.028c0.185-0.005,2.667,4.292,2.854,4.292 c11.761,0,17.229,6.336,17.229,17.293c0,7.617-2.854,12.472-9.606,15.798c-1.295,9.799-10.257,17.392-21.127,17.392 c-6.615,0-12.524-2.812-16.436-7.22c-0.649,0.059-1.312,0.09-1.979,0.09c-11.765,0-20.998-5.572-20.998-16.527 c0-7.379,3.301-11.018,9.31-15.396c-0.16-0.948-0.827-9.299,1.4-11.524c5.292-5.293,7.688-9.84,12.424-12.191 c-9.292,3.341-15.888,11.735-15.888,21.572c0,0.166,0.01,0.33,0.014,0.495c-7.497,3.977-12.554,11.479-12.554,20.098 c0,12.771,11.107,23.118,24.812,23.118c0.78,0,1.548-0.037,2.313-0.104c4.552,5.139,11.438,8.41,19.146,8.41 c12.667,0,23.107-8.845,24.621-20.267c7.877-3.873,13.249-11.575,13.249-20.448 C142.973,112.778,131.862,102.426,118.158,102.426z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.84,138.882c0,0,12.85,2.517,12.85,15.093c0,0,3.46,21.358-9.915,36.479h30.882 c-0.309-0.428-26.975-36.051,2.704-57.229C101.263,143.57,82.84,138.882,82.84,138.882z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.656,191.953H82.445l2.206-2.494c12.729-14.391,9.591-35.039,9.558-35.246l-0.019-0.238 c0-10.15-9.382-13.056-11.323-13.547c-0.261-0.058-0.396-0.092-0.396-0.092l0.658-2.926c0,0,0.152,0.028,0.425,0.097 c1.034,0.226,4.694,0.935,9.765,0.935c6.338,0,15.873-1.131,25.298-6.519l1.616,2.522 c-7.364,5.255-11.735,11.898-12.991,19.746c-2.671,16.684,9.239,33.486,10.605,35.347l1.754,2.389L116.656,191.953z  M88.926,188.953h24.889c-3.732-5.774-11.903-20.457-9.537-35.236c0.91-5.683,3.278-10.779,7.066-15.233 c-6.88,2.36-13.296,2.958-18.026,2.958c-0.675,0-1.326-0.012-1.951-0.032c3.047,2.482,5.787,6.396,5.822,12.447 C97.469,155.71,99.919,174.224,88.926,188.953z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.978,113.661",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.659,138.85c0,0-19.497,25.172-4.515,51.604h9.514 C116.658,190.451,96.871,162.796,111.659,138.85z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.728,148.964c0-11.553-10.051-20.913-22.448-20.913c-0.188,0-0.38,0.008-0.567,0.014 c-3.917-6.129-11.093-10.233-19.3-10.233c-12.397,0-22.445,9.36-22.445,20.915c0,0.146,0.011,0.297,0.013,0.445 c-6.776,3.604-11.354,10.395-11.354,18.186c0,11.559,10.047,20.918,22.441,20.918c0.704,0,1.4-0.034,2.086-0.099 c4.118,4.649,10.354,7.612,17.323,7.612c11.459,0,20.904-8.004,22.271-18.336C238.868,163.962,243.728,156.998,243.728,148.964 z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.477,187.309c-6.892,0-13.384-2.746-17.936-7.56c-0.493,0.03-0.986,0.046-1.474,0.046 c-13.201,0-23.941-10.057-23.941-22.418c0-7.756,4.323-14.98,11.345-19.062c0.247-12.161,10.892-21.983,23.941-21.983 c8.081,0,15.699,3.896,20.094,10.221c13.101,0.114,23.722,10.124,23.722,22.412c0,8.098-4.62,15.498-12.111,19.493 C231.272,179.26,221.256,187.309,209.477,187.309z M192.772,176.632l0.505,0.57c4,4.516,9.905,7.106,16.2,7.106 c10.564,0,19.5-7.322,20.784-17.032l0.105-0.795l0.719-0.354c6.873-3.389,11.143-9.965,11.143-17.163 c0-10.704-9.397-19.413-20.948-19.413c-0.136,0-0.274,0.005-0.411,0.01l-0.961,0.03l-0.459-0.719 c-3.762-5.885-10.673-9.541-18.036-9.541c-11.549,0-20.945,8.71-20.945,19.415l0.024,1.34l-0.808,0.43 c-6.512,3.464-10.558,9.925-10.558,16.861c0,10.707,9.395,19.418,20.941,19.418c0.642,0,1.296-0.031,1.945-0.092 L192.772,176.632z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.902,127.296c-0.189,0-0.383,0.009-0.571,0.015 c-3.142-4.914-8.374-8.523-14.562-9.768c4.896,1.229,9.019,4.203,11.547,8.166c0.163-0.004,2.413,3.885,2.58,3.885 c10.642,0,15.585,5.729,15.585,15.646c0,6.893-2.579,11.278-8.69,14.291c-1.171,8.862-9.278,15.731-19.111,15.731 c-5.984,0-11.329-2.545-14.863-6.531c-0.591,0.055-1.188,0.082-1.793,0.082c-10.639,0-18.996-5.043-18.996-14.953 c0-6.678,2.985-9.963,8.426-13.93c-0.146-0.858-0.753-8.41,1.268-10.426c4.788-4.789,6.958-8.902,11.24-11.028 c-8.404,3.021-14.372,10.616-14.372,19.514c0,0.147,0.013,0.298,0.016,0.449c-6.779,3.599-11.355,10.392-11.355,18.181 c0,11.551,10.05,20.914,22.445,20.914c0.706,0,1.4-0.031,2.089-0.095c4.118,4.646,10.353,7.609,17.32,7.609 c11.458,0,20.903-8.004,22.271-18.334c7.126-3.504,11.984-10.473,11.984-18.502C243.35,136.66,233.301,127.296,220.902,127.296z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M188.953,160.277c0,0,11.624,2.271,11.624,13.649c0,0,3.13,19.318-8.973,32.992h27.938 c-0.276-0.383-24.398-32.604,2.447-51.767C205.619,164.518,188.953,160.277,188.953,160.277z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.543,208.419h-31.27l2.208-2.494c11.472-12.961,8.645-31.573,8.615-31.76l-0.02-0.238 c0-9.069-8.386-11.669-10.128-12.11c-0.24-0.054-0.366-0.085-0.366-0.085l0.658-2.926c0,0,0.141,0.026,0.394,0.09 c0.934,0.203,4.227,0.84,8.789,0.84c5.719,0,14.319-1.021,22.821-5.885l1.616,2.522c-6.63,4.732-10.563,10.713-11.693,17.774 c-2.405,15.037,8.334,30.183,9.566,31.859l1.755,2.389L219.543,208.419z M194.74,205.419h21.97 c-3.445-5.383-10.621-18.514-8.504-31.746c0.8-5.003,2.842-9.506,6.096-13.462c-6.062,2.009-11.696,2.524-15.878,2.524 c-0.461,0-0.91-0.007-1.346-0.018c2.65,2.274,4.965,5.779,4.999,11.091C202.337,175.545,204.504,192.119,194.74,205.419z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.314,137.46",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.023,160.246c0,0-17.637,22.771-4.081,46.678h8.604 C219.544,206.921,201.646,181.91,215.023,160.246z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.009,147.232c0-12.271-10.675-22.213-23.843-22.213c-0.206,0-0.408,0.006-0.611,0.012 c-4.158-6.508-11.781-10.868-20.5-10.868c-13.167,0-23.844,9.946-23.844,22.213c0,0.158,0.011,0.313,0.014,0.474 c-7.201,3.823-12.062,11.039-12.062,19.315c0,12.267,10.675,22.213,23.843,22.213c0.749,0,1.488-0.039,2.22-0.099 c4.374,4.935,10.991,8.084,18.397,8.084c12.171,0,22.205-8.5,23.651-19.476C84.849,163.164,90.009,155.762,90.009,147.232z",
    style: {
      fill: "#D7F7E4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.623,187.863c-7.308,0-14.194-2.92-19.015-8.036c-0.567,0.034-1.096,0.051-1.603,0.051 c-13.974,0-25.343-10.638-25.343-23.713c0-8.228,4.594-15.886,12.051-20.193c0.231-12.89,11.51-23.309,25.34-23.309 c8.573,0,16.652,4.14,21.296,10.857c13.89,0.093,25.158,10.694,25.158,23.712c0,8.587-4.909,16.427-12.866,20.641 C76.717,179.324,66.108,187.863,53.623,187.863z M35.851,176.724l0.497,0.561c4.27,4.816,10.566,7.579,17.275,7.579 c11.271,0,20.799-7.812,22.164-18.172l0.105-0.796l0.721-0.354c7.338-3.607,11.896-10.623,11.896-18.31 c0-11.421-10.023-20.713-22.343-20.713c-0.19,0-0.377,0.006-0.565,0.011l-0.85,0.024l-0.46-0.716 c-4.01-6.276-11.381-10.176-19.236-10.176c-12.32,0-22.344,9.292-22.344,20.713l0.03,1.367l-0.813,0.432 c-6.949,3.688-11.265,10.582-11.265,17.99c0,11.421,10.023,20.713,22.343,20.713c0.638,0,1.324-0.03,2.098-0.094 L35.851,176.724z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.766,124.219c-0.205,0-0.407,0.008-0.609,0.012 c-3.33-5.215-8.896-9.057-15.465-10.373c5.197,1.304,9.574,4.466,12.269,8.675c0.174-0.004,2.562,4.123,2.736,4.123 c11.304,0,16.56,6.09,16.56,16.617c0,7.315-2.741,11.979-9.236,15.18c-1.245,9.42-9.854,16.709-20.3,16.709 c-6.355,0-12.033-2.701-15.788-6.936c-0.627,0.053-1.261,0.086-1.904,0.086c-11.3,0-20.177-5.355-20.177-15.886 c0-7.09,3.173-10.584,8.947-14.793c-0.154-0.911-0.795-8.938,1.345-11.075c5.086-5.084,7.39-9.455,11.939-11.71 c-8.932,3.209-15.27,11.276-15.27,20.724c0,0.158,0.009,0.315,0.017,0.477c-7.202,3.82-12.063,11.033-12.063,19.313 c0,12.266,10.674,22.211,23.843,22.211c0.75,0,1.489-0.035,2.225-0.099c4.374,4.936,10.986,8.084,18.396,8.084 c12.171,0,22.204-8.498,23.655-19.473c7.569-3.725,12.729-11.129,12.729-19.652C89.61,134.164,78.935,124.219,65.766,124.219z",
    style: {
      opacity: 0.1,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.832,159.25c0,0,12.346,2.416,12.346,14.5c0,0,3.325,20.523-9.525,35.045h29.675 c-0.298-0.406-25.916-34.639,2.599-54.984C49.532,163.75,31.832,159.25,31.832,159.25z",
    style: {
      fill: "#EDE3DA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.327,210.295H31.322l2.207-2.494c12.211-13.799,9.2-33.613,9.168-33.812l-0.019-0.238 c0-9.709-8.975-12.487-10.835-12.958c-0.25-0.055-0.38-0.088-0.38-0.088l0.658-2.926c0,0,0.146,0.027,0.409,0.093 c0.992,0.217,4.499,0.896,9.361,0.896c6.085,0,15.24-1.086,24.291-6.259l1.615,2.523c-7.075,5.048-11.268,11.432-12.465,18.974 C52.738,190.36,65,207.181,65.523,207.889l1.767,2.392L64.327,210.295z M37.798,207.295h23.683 c-3.615-5.592-11.362-19.57-9.111-33.76c0.86-5.421,3.096-10.288,6.673-14.549c-6.548,2.217-12.646,2.78-17.152,2.78 c-0.584,0-1.15-0.01-1.695-0.026c2.884,2.398,5.447,6.144,5.482,11.892C45.949,175.438,48.283,193.155,37.798,207.295z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.65,135.012",
    style: {
      fill: "#D57E58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.521,159.214c0,0-18.73,24.188-4.335,49.578h9.141 C64.323,208.792,45.313,182.227,59.521,159.214z",
    style: {
      opacity: 0.11,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 42,
    width: 65,
    style: {
      fill: "#FFFFFF"
    },
    y: 116.289,
    x: 1.557
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.557,159.789h-65c-0.829,0-1.5-0.672-1.5-1.5v-42c0-0.829,0.671-1.5,1.5-1.5h65 c0.829,0,1.5,0.671,1.5,1.5v42C68.057,159.117,67.385,159.789,66.557,159.789z M3.057,156.789h62v-39h-62V156.789z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 32,
    style: {
      fill: "#CCCCDE"
    },
    y: 125.289,
    x: 9.557
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 15,
    style: {
      fill: "#CCCCDE"
    },
    y: 133.289,
    x: 9.557
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 10.5,
    style: {
      fill: "#CCCCDE"
    },
    y: 133.789,
    x: 34.057
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 9.25,
    style: {
      fill: "#CCCCDE"
    },
    y: 124.789,
    x: 47.557
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 27.125,
    style: {
      fill: "#CCCCDE"
    },
    y: 140.789,
    x: 9.557
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "220.367,86.965 185.163,86.965 185.163,31.419 240.708,31.419 240.708,66.624",
    style: {
      fill: "#FAFFFA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.367,88.465h-35.204c-0.828,0-1.5-0.671-1.5-1.5V31.419c0-0.829,0.672-1.5,1.5-1.5h55.545 c0.828,0,1.5,0.671,1.5,1.5v35.205c0,0.398-0.158,0.779-0.439,1.061l-20.341,20.341 C221.147,88.307,220.765,88.465,220.367,88.465z M186.663,85.465h33.083l19.462-19.462V32.919h-52.545V85.465z",
    style: {
      fill: "#CCCCDE"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "220.367,86.965 220.367,66.624 240.708,66.624",
    style: {
      fill: "#EDFFEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.367,88.465c-0.193,0-0.389-0.037-0.574-0.114c-0.561-0.232-0.926-0.779-0.926-1.386V66.624 c0-0.829,0.672-1.5,1.5-1.5h20.341c0.606,0,1.153,0.365,1.386,0.926s0.104,1.206-0.325,1.635l-20.341,20.341 C221.141,88.312,220.757,88.465,220.367,88.465z M221.867,68.124v15.22l15.22-15.22H221.867z",
    style: {
      fill: "#CCCCDE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.409,196.312h-3v-90.106c0-2.354-1.915-4.268-4.269-4.268h-0.17 c-2.354,0-4.268,1.915-4.268,4.268v8.036c0,4.007-3.261,7.268-7.269,7.268h-20.256v-3h20.256c2.354,0,4.269-1.915,4.269-4.268 v-8.036c0-4.008,3.26-7.268,7.268-7.268h0.17c4.008,0,7.269,3.26,7.269,7.268V196.312z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.621,198.375h-3v-90.106c0-2.354-1.915-4.268-4.269-4.268h-0.17 c-2.354,0-4.268,1.915-4.268,4.268v8.037c0,4.007-3.261,7.267-7.269,7.267h-20.256v-3h20.256c2.354,0,4.269-1.914,4.269-4.267 v-8.037c0-4.008,3.26-7.268,7.268-7.268h0.17c4.008,0,7.269,3.26,7.269,7.268V198.375z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.982,181.986c0,1.649-1.268,3-2.816,3s-2.817-1.351-2.817-3v-4.902c0-1.65,1.269-3,2.817-3 s2.816,1.35,2.816,3V181.986z",
    style: {
      fill: "#D5D7E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.165,186.486c-2.381,0-4.317-2.019-4.317-4.5v-4.902c0-2.481,1.937-4.5,4.317-4.5 c2.38,0,4.316,2.019,4.316,4.5v4.902C228.482,184.468,226.545,186.486,224.165,186.486z M224.165,175.584 c-0.714,0-1.317,0.687-1.317,1.5v4.902c0,0.813,0.604,1.5,1.317,1.5s1.316-0.687,1.316-1.5v-4.902 C225.482,176.271,224.879,175.584,224.165,175.584z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.749,219.296c0,9.953-7.431,18.097-16.505,18.097c-9.077,0-16.504-8.144-16.504-18.097 v-21.715c0-9.954,7.427-18.097,16.504-18.097c9.074,0,16.505,8.143,16.505,18.097V219.296z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.016,224.539v-21.715 c0-9.953,7.427-18.096,16.504-18.096c5.313,0,10.062,2.793,13.084,7.104c-2.294-6.979-8.403-12.005-15.533-12.005 c-9.076,0-16.505,8.142-16.505,18.096v21.715c0,4.127,1.279,7.938,3.42,10.991C210.36,228.725,210.016,226.674,210.016,224.539z",
    style: {
      opacity: 0.3,
      fill: "#F5F5F5",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.244,238.893c-9.928,0-18.004-8.791-18.004-19.597v-21.715 c0-10.806,8.076-19.597,18.004-19.597s18.005,8.791,18.005,19.597v21.715C242.249,230.102,234.172,238.893,224.244,238.893z  M224.244,180.984c-8.273,0-15.004,7.445-15.004,16.597v21.715c0,9.151,6.73,16.597,15.004,16.597s15.005-7.445,15.005-16.597 v-21.715C239.249,188.43,232.518,180.984,224.244,180.984z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.658,182.745c2.433,3.153,3.905,7.222,3.905,11.651 v21.715c0,9.953-7.43,18.097-16.505,18.097c-3.492,0-6.738-1.21-9.414-3.26c3.034,3.934,7.562,6.444,12.6,6.444 c9.074,0,16.505-8.145,16.505-18.098V197.58C240.749,191.457,237.935,186.023,233.658,182.745z",
    style: {
      opacity: 0.25,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.907,193.691c-0.828,0-1.5-0.672-1.5-1.5V180.22c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5 v11.972C225.407,193.02,224.736,193.691,223.907,193.691z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.813,230.344c0,3.496-0.742,6.354-6.354,6.359l-104.104,0.1 c-5.611,0.006-6.354-2.854-6.354-6.347v-39.813c0-3.496,0.743-6.354,6.354-6.358l104.104-0.101 c5.61-0.005,6.354,2.854,6.354,6.348V230.344z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.338,238.303c-6.946,0-7.836-4.193-7.836-7.847v-39.813c0-3.655,0.893-7.853,7.852-7.858 l104.105-0.101c6.964,0,7.854,4.194,7.854,7.848v39.812c0,3.656-0.893,7.854-7.853,7.859L55.338,238.303z M159.474,185.684 l-104.118,0.101c-4.517,0.004-4.855,1.926-4.855,4.858v39.813c0,2.928,0.336,4.847,4.836,4.847v1.5l0.016-1.5l104.105-0.1 c4.517-0.004,4.854-1.927,4.854-4.859v-39.812C164.313,187.603,163.976,185.684,159.474,185.684z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.576,203.788v-3.744c0-0.758-0.699-1.378-1.56-1.378H77.44c-0.855,0-1.558,0.62-1.558,1.378 v3.744c0,0.759,0.701,1.381,1.558,1.381h4.577C82.876,205.169,83.576,204.547,83.576,203.788z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.017,205.669H77.44c-1.135,0-2.058-0.844-2.058-1.881v-3.744c0-1.035,0.923-1.878,2.058-1.878 h4.577c1.136,0,2.06,0.843,2.06,1.878v3.744C84.076,204.825,83.153,205.669,82.017,205.669z M77.44,199.166 c-0.573,0-1.058,0.402-1.058,0.878v3.744c0,0.478,0.484,0.881,1.058,0.881h4.577c0.574,0,1.06-0.403,1.06-0.881v-3.744 c0-0.484-0.475-0.878-1.06-0.878H77.44z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.284,203.788v-3.744c0-0.758-0.701-1.378-1.559-1.378h-4.578c-0.855,0-1.558,0.62-1.558,1.378 v3.744c0,0.759,0.701,1.381,1.558,1.381h4.578C72.583,205.169,73.284,204.547,73.284,203.788z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.726,205.669h-4.578c-1.135,0-2.058-0.844-2.058-1.881v-3.744 c0-1.035,0.923-1.878,2.058-1.878h4.578c1.135,0,2.059,0.843,2.059,1.878v3.744C73.784,204.825,72.861,205.669,71.726,205.669z  M67.148,199.166c-0.573,0-1.058,0.402-1.058,0.878v3.744c0,0.478,0.484,0.881,1.058,0.881h4.578 c0.574,0,1.059-0.403,1.059-0.881v-3.744c0-0.476-0.485-0.878-1.059-0.878H67.148z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.312,205.169c0.856,0,1.558-0.622,1.558-1.381v-3.744c0-0.758-0.7-1.378-1.558-1.378h-4.579 c-0.856,0-1.558,0.62-1.558,1.378v3.744c0,0.759,0.701,1.381,1.558,1.381H92.312z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.312,205.669h-4.579c-1.135,0-2.058-0.844-2.058-1.881v-3.744 c0-1.035,0.923-1.878,2.058-1.878h4.579c1.135,0,2.058,0.843,2.058,1.878v3.744C94.369,204.825,93.447,205.669,92.312,205.669z  M87.733,199.166c-0.573,0-1.058,0.402-1.058,0.878v3.744c0,0.478,0.484,0.881,1.058,0.881h4.579 c0.573,0,1.058-0.403,1.058-0.881v-3.744c0-0.476-0.484-0.878-1.058-0.878H87.733z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.188,205.169c0.856,0,1.559-0.622,1.559-1.381v-3.744c0-0.758-0.701-1.378-1.559-1.378 h-4.579c-0.854,0-1.557,0.62-1.557,1.378v3.744c0,0.759,0.701,1.381,1.557,1.381H123.188z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.188,205.669h-4.579c-1.134,0-2.057-0.844-2.057-1.881v-3.744 c0-1.035,0.922-1.878,2.057-1.878h4.579c1.135,0,2.059,0.843,2.059,1.878v3.744 C125.246,204.825,124.323,205.669,123.188,205.669z M118.609,199.166c-0.573,0-1.057,0.402-1.057,0.878v3.744 c0,0.478,0.484,0.881,1.057,0.881h4.579c0.574,0,1.059-0.403,1.059-0.881v-3.744c0-0.476-0.485-0.878-1.059-0.878H118.609z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.604,205.169c0.856,0,1.558-0.622,1.558-1.381v-3.744c0-0.758-0.701-1.378-1.558-1.378 h-4.579c-0.855,0-1.557,0.62-1.557,1.378v3.744c0,0.759,0.7,1.381,1.557,1.381H102.604z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.604,205.669h-4.579c-1.134,0-2.057-0.844-2.057-1.881v-3.744 c0-1.035,0.922-1.878,2.057-1.878h4.579c1.135,0,2.058,0.843,2.058,1.878v3.744 C104.661,204.825,103.739,205.669,102.604,205.669z M98.025,199.166c-0.573,0-1.057,0.402-1.057,0.878v3.744 c0,0.478,0.484,0.881,1.057,0.881h4.579c0.573,0,1.058-0.403,1.058-0.881v-3.744c0-0.476-0.484-0.878-1.058-0.878H98.025z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.318,205.169h4.579c0.856,0,1.559-0.622,1.559-1.381v-3.744c0-0.758-0.701-1.378-1.559-1.378 h-4.579c-0.855,0-1.559,0.62-1.559,1.378v3.744C106.759,204.547,107.461,205.169,108.318,205.169z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.897,205.669h-4.579c-1.135,0-2.059-0.844-2.059-1.881v-3.744 c0-1.035,0.923-1.878,2.059-1.878h4.579c1.135,0,2.059,0.843,2.059,1.878v3.744 C114.955,204.825,114.032,205.669,112.897,205.669z M108.318,199.166c-0.574,0-1.059,0.402-1.059,0.878v3.744 c0,0.478,0.485,0.881,1.059,0.881h4.579c0.574,0,1.059-0.403,1.059-0.881v-3.744c0-0.476-0.485-0.878-1.059-0.878H108.318z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.481,205.169c0.857,0,1.561-0.622,1.561-1.381v-3.744c0-0.758-0.702-1.378-1.561-1.378 h-4.578c-0.857,0-1.557,0.62-1.557,1.378v3.744c0,0.759,0.698,1.381,1.557,1.381H133.481z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.481,205.669h-4.578c-1.134,0-2.057-0.844-2.057-1.881v-3.744 c0-1.035,0.922-1.878,2.057-1.878h4.578c1.136,0,2.061,0.843,2.061,1.878v3.744 C135.541,204.825,134.616,205.669,133.481,205.669z M128.903,199.166c-0.573,0-1.057,0.402-1.057,0.878v3.744 c0,0.485,0.474,0.881,1.057,0.881h4.578c0.575,0,1.061-0.403,1.061-0.881v-3.744c0-0.476-0.485-0.878-1.061-0.878H128.903z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.637,200.044v3.744c0,0.759,0.702,1.381,1.559,1.381h4.579c0.854,0,1.559-0.622,1.559-1.381 v-3.744c0-0.758-0.703-1.378-1.559-1.378h-4.579C138.338,198.666,137.637,199.286,137.637,200.044z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.775,205.669h-4.579c-1.135,0-2.059-0.844-2.059-1.881v-3.744 c0-1.035,0.924-1.878,2.059-1.878h4.579c1.135,0,2.059,0.843,2.059,1.878v3.744 C145.833,204.825,144.909,205.669,143.775,205.669z M139.196,199.166c-0.574,0-1.059,0.402-1.059,0.878v3.744 c0,0.478,0.484,0.881,1.059,0.881h4.579c0.574,0,1.059-0.403,1.059-0.881v-3.744c0-0.476-0.484-0.878-1.059-0.878H139.196z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.856,205.169h4.579c0.856,0,1.558-0.622,1.558-1.381v-3.744c0-0.758-0.7-1.378-1.558-1.378 h-4.579c-0.856,0-1.558,0.62-1.558,1.378v3.744C55.298,204.547,55.998,205.169,56.856,205.169z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.435,205.669h-4.579c-1.135,0-2.058-0.844-2.058-1.881v-3.744 c0-1.035,0.923-1.878,2.058-1.878h4.579c1.135,0,2.058,0.843,2.058,1.878v3.744C63.492,204.825,62.57,205.669,61.435,205.669z  M56.856,199.166c-0.573,0-1.058,0.402-1.058,0.878v3.744c0,0.478,0.484,0.881,1.058,0.881h4.579 c0.573,0,1.058-0.403,1.058-0.881v-3.744c0-0.476-0.484-0.878-1.058-0.878H56.856z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.959,198.666h-8.474c-0.854,0-1.557,0.62-1.557,1.378v3.744c0,0.759,0.701,1.381,1.557,1.381 h8.474c0.856,0,1.559-0.622,1.559-1.381v-3.744C159.516,199.286,158.817,198.666,157.959,198.666z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.959,205.669h-8.474c-1.134,0-2.057-0.844-2.057-1.881v-3.744 c0-1.035,0.923-1.878,2.057-1.878h8.474c1.133,0,2.056,0.842,2.059,1.877v3.745 C160.018,204.825,159.094,205.669,157.959,205.669z M149.486,199.166c-0.573,0-1.057,0.402-1.057,0.878v3.744 c0,0.478,0.483,0.881,1.057,0.881h8.474c0.574,0,1.059-0.403,1.059-0.881v-3.744c-0.001-0.483-0.477-0.878-1.059-0.878H149.486z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.056,211.771v-3.746c0-0.758-0.702-1.379-1.559-1.379h-4.2c-0.855,0-1.557,0.621-1.557,1.379 v3.746c0,0.758,0.7,1.377,1.557,1.377h4.2C125.354,213.148,126.056,212.527,126.056,211.771z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.497,213.648h-4.2c-1.134,0-2.057-0.842-2.057-1.877v-3.746c0-1.036,0.922-1.879,2.057-1.879 h4.2c1.135,0,2.059,0.843,2.059,1.879v3.746C126.556,212.807,125.633,213.648,124.497,213.648z M120.297,207.146 c-0.573,0-1.057,0.402-1.057,0.879v3.746c0,0.476,0.484,0.877,1.057,0.877h4.2c0.574,0,1.059-0.401,1.059-0.877v-3.746 c0-0.477-0.485-0.879-1.059-0.879H120.297z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.323,211.771v-3.746c0-0.758-0.701-1.379-1.558-1.379h-4.202 c-0.854,0-1.557,0.621-1.557,1.379v3.746c0,0.758,0.701,1.377,1.557,1.377h4.202 C106.622,213.148,107.323,212.527,107.323,211.771z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.766,213.648h-4.202c-1.134,0-2.057-0.842-2.057-1.877v-3.746 c0-1.036,0.922-1.879,2.057-1.879h4.202c1.135,0,2.058,0.843,2.058,1.879v3.746 C107.823,212.807,106.901,213.648,105.766,213.648z M101.564,207.146c-0.573,0-1.057,0.402-1.057,0.879v3.746 c0,0.476,0.484,0.877,1.057,0.877h4.202c0.573,0,1.058-0.401,1.058-0.877v-3.746c0-0.477-0.484-0.879-1.058-0.879H101.564z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.689,211.771v-3.746c0-0.758-0.701-1.379-1.557-1.379h-4.201 c-0.854,0-1.558,0.621-1.558,1.379v3.746c0,0.758,0.703,1.377,1.558,1.377h4.201 C115.988,213.148,116.689,212.527,116.689,211.771z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.132,213.648h-4.201c-1.135,0-2.058-0.842-2.058-1.877v-3.746 c0-1.036,0.923-1.879,2.058-1.879h4.201c1.134,0,2.057,0.843,2.057,1.879v3.746 C117.189,212.807,116.266,213.648,115.132,213.648z M110.931,207.146c-0.573,0-1.058,0.402-1.058,0.879v3.746 c0,0.476,0.484,0.877,1.058,0.877h4.201c0.573,0,1.057-0.401,1.057-0.877v-3.746c0-0.477-0.484-0.879-1.057-0.879H110.931z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.787,211.771v-3.746c0-0.758-0.701-1.379-1.56-1.379h-4.199 c-0.856,0-1.558,0.621-1.558,1.379v3.746c0,0.758,0.7,1.377,1.558,1.377h4.199C144.086,213.148,144.787,212.527,144.787,211.771 z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.228,213.648h-4.199c-1.135,0-2.058-0.842-2.058-1.877v-3.746 c0-1.036,0.923-1.879,2.058-1.879h4.199c1.136,0,2.06,0.843,2.06,1.879v3.746C145.287,212.807,144.364,213.648,143.228,213.648z  M139.029,207.146c-0.573,0-1.058,0.402-1.058,0.879v3.746c0,0.476,0.484,0.877,1.058,0.877h4.199 c0.574,0,1.06-0.401,1.06-0.877v-3.746c0-0.477-0.485-0.879-1.06-0.879H139.029z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.468,213.148h4.201c0.856,0,1.558-0.621,1.558-1.379v-3.744c0-0.758-0.701-1.379-1.558-1.379 h-4.201c-0.856,0-1.557,0.621-1.557,1.379v3.744C71.911,212.527,72.613,213.148,73.468,213.148z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.669,213.648h-4.201c-1.134,0-2.057-0.843-2.057-1.879v-3.744 c0-1.036,0.922-1.879,2.057-1.879h4.201c1.135,0,2.058,0.843,2.058,1.879v3.744C79.727,212.806,78.804,213.648,77.669,213.648z  M73.468,207.146c-0.573,0-1.057,0.402-1.057,0.879v3.744c0,0.477,0.484,0.879,1.057,0.879h4.201 c0.573,0,1.058-0.402,1.058-0.879v-3.744c0-0.477-0.484-0.879-1.058-0.879H73.468z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.835,213.148h4.199c0.856,0,1.557-0.621,1.557-1.379v-3.744c0-0.758-0.699-1.379-1.557-1.379 h-4.199c-0.858,0-1.56,0.621-1.56,1.379v3.744C81.277,212.527,81.977,213.148,82.835,213.148z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.034,213.648h-4.199c-1.134,0-2.058-0.843-2.06-1.878v-3.745c0-1.036,0.924-1.879,2.06-1.879 h4.199c1.134,0,2.057,0.843,2.057,1.879v3.744C89.091,212.806,88.169,213.648,87.034,213.648z M82.835,207.146 c-0.574,0-1.06,0.402-1.06,0.879v3.744c0,0.477,0.486,0.879,1.06,0.879h4.199c0.573,0,1.057-0.402,1.057-0.879v-3.744 c0-0.477-0.484-0.879-1.057-0.879H82.835z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.663,213.148h4.199c0.856,0,1.558-0.621,1.558-1.379v-3.744c0-0.758-0.7-1.379-1.558-1.379 h-4.199c-0.856,0-1.559,0.621-1.559,1.379v3.744C128.106,212.527,128.807,213.148,129.663,213.148z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.863,213.648h-4.199c-1.134,0-2.057-0.843-2.059-1.878v-3.745 c0-1.036,0.924-1.879,2.059-1.879h4.199c1.135,0,2.058,0.843,2.058,1.879v3.744C135.92,212.806,134.997,213.648,133.863,213.648 z M129.663,207.146c-0.574,0-1.059,0.402-1.059,0.879v3.744c0.001,0.477,0.485,0.879,1.059,0.879h4.199 c0.573,0,1.058-0.402,1.058-0.879v-3.744c0-0.477-0.484-0.879-1.058-0.879H129.663z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.957,211.771v-3.746c0-0.758-0.7-1.379-1.559-1.379H92.2c-0.858,0-1.558,0.621-1.558,1.379 v3.746c0,0.758,0.699,1.377,1.558,1.377H96.4C97.257,213.148,97.957,212.527,97.957,211.771z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4,213.648H92.2c-1.135,0-2.058-0.842-2.058-1.877v-3.746c0-1.036,0.923-1.879,2.058-1.879 h4.198c1.135,0,2.059,0.843,2.059,1.879v3.746C98.457,212.807,97.534,213.648,96.4,213.648z M92.2,207.146 c-0.573,0-1.058,0.402-1.058,0.879v3.746c0,0.483,0.475,0.877,1.058,0.877H96.4c0.573,0,1.058-0.401,1.058-0.877v-3.746 c0-0.477-0.485-0.879-1.059-0.879H92.2z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.298,211.771c0,0.758,0.7,1.377,1.558,1.377h11.356c0.855,0,1.557-0.619,1.557-1.377v-3.746 c0-0.758-0.7-1.379-1.557-1.379H56.856c-0.856,0-1.558,0.621-1.558,1.379V211.771z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.212,213.648H56.856c-1.135,0-2.058-0.842-2.058-1.877v-3.746 c0-1.036,0.923-1.879,2.058-1.879h11.356c1.134,0,2.057,0.843,2.057,1.879v3.746C70.269,212.807,69.346,213.648,68.212,213.648z  M56.856,207.146c-0.573,0-1.058,0.402-1.058,0.879v3.746c0,0.476,0.484,0.877,1.058,0.877h11.356 c0.573,0,1.057-0.401,1.057-0.877v-3.746c0-0.477-0.484-0.879-1.057-0.879H56.856z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.959,206.646h-9.539c-0.855,0-1.558,0.621-1.558,1.379v3.744 c0,0.758,0.701,1.379,1.558,1.379h9.539c0.856,0,1.559-0.621,1.559-1.379v-3.744 C159.516,207.268,158.817,206.646,157.959,206.646z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.959,213.648h-9.539c-1.135,0-2.058-0.843-2.058-1.879v-3.744 c0-1.036,0.923-1.879,2.058-1.879h9.539c1.133,0,2.056,0.843,2.059,1.878v3.745 C160.018,212.806,159.094,213.648,157.959,213.648z M148.42,207.146c-0.573,0-1.058,0.402-1.058,0.879v3.744 c0,0.477,0.484,0.879,1.058,0.879h9.539c0.574,0,1.059-0.402,1.059-0.879v-3.744c-0.001-0.476-0.486-0.879-1.059-0.879H148.42z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.862,214.921H78.66c-0.856,0-1.559,0.623-1.559,1.382v3.744c0,0.756,0.701,1.377,1.559,1.377 h4.201c0.855,0,1.558-0.621,1.558-1.377v-3.744C84.418,215.544,83.717,214.921,82.862,214.921z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.862,221.924H78.66c-1.135,0-2.059-0.842-2.059-1.877v-3.744c0-1.038,0.923-1.882,2.059-1.882 h4.201c1.133,0,2.056,0.844,2.058,1.881v3.745C84.919,221.082,83.996,221.924,82.862,221.924z M78.66,215.421 c-0.574,0-1.059,0.404-1.059,0.882v3.744c0,0.476,0.485,0.877,1.059,0.877h4.201c0.573,0,1.058-0.401,1.058-0.877v-3.744 c0-0.478-0.485-0.882-1.058-0.882H78.66z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.03,221.424h4.2c0.856,0,1.559-0.621,1.559-1.377v-3.744c0-0.759-0.701-1.382-1.559-1.382 h-4.2c-0.856,0-1.558,0.623-1.558,1.382v3.744C86.472,220.803,87.172,221.424,88.03,221.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.23,221.924h-4.2c-1.135,0-2.058-0.842-2.058-1.877v-3.744c0-1.038,0.923-1.882,2.058-1.882 h4.2c1.135,0,2.059,0.844,2.059,1.882v3.744C94.288,221.082,93.365,221.924,92.23,221.924z M88.03,215.421 c-0.573,0-1.058,0.404-1.058,0.882v3.744c0,0.476,0.484,0.877,1.058,0.877h4.2c0.574,0,1.059-0.401,1.059-0.877v-3.744 c0-0.478-0.485-0.882-1.059-0.882H88.03z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.877,221.424h4.199c0.854,0,1.558-0.621,1.558-1.377v-3.744c0-0.759-0.702-1.382-1.558-1.382 h-4.199c-0.857,0-1.56,0.623-1.56,1.382v3.744C133.319,220.803,134.02,221.424,134.877,221.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.076,221.924h-4.199c-1.135,0-2.059-0.842-2.06-1.876v-3.745c0-1.038,0.924-1.882,2.06-1.882 h4.199c1.135,0,2.058,0.844,2.058,1.882v3.744C141.134,221.082,140.211,221.924,139.076,221.924z M134.877,215.421 c-0.574,0-1.06,0.404-1.06,0.882v3.744c0.001,0.475,0.485,0.877,1.06,0.877h4.199c0.573,0,1.058-0.401,1.058-0.877v-3.744 c0-0.478-0.484-0.882-1.058-0.882H134.877z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.399,221.424h4.199c0.858,0,1.559-0.621,1.559-1.377v-3.744c0-0.759-0.7-1.382-1.559-1.382 h-4.199c-0.856,0-1.558,0.623-1.558,1.382v3.744C95.841,220.803,96.541,221.424,97.399,221.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.598,221.924h-4.199c-1.135,0-2.058-0.842-2.058-1.877v-3.744 c0-1.038,0.923-1.882,2.058-1.882h4.199c1.135,0,2.059,0.844,2.059,1.882v3.744 C103.656,221.082,102.733,221.924,101.598,221.924z M97.399,215.421c-0.573,0-1.058,0.404-1.058,0.882v3.744 c0,0.476,0.484,0.877,1.058,0.877h4.199c0.574,0,1.059-0.401,1.059-0.877v-3.744c0-0.478-0.485-0.882-1.059-0.882H97.399z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.265,220.047v-3.744c0-0.759-0.702-1.382-1.558-1.382h-4.201 c-0.855,0-1.557,0.623-1.557,1.382v3.744c0,0.756,0.7,1.377,1.557,1.377h4.201C130.563,221.424,131.265,220.803,131.265,220.047 z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.707,221.924h-4.201c-1.134,0-2.057-0.842-2.057-1.877v-3.744 c0-1.038,0.922-1.882,2.057-1.882h4.201c1.135,0,2.058,0.844,2.058,1.882v3.744 C131.765,221.082,130.842,221.924,129.707,221.924z M125.506,215.421c-0.573,0-1.057,0.404-1.057,0.882v3.744 c0,0.476,0.484,0.877,1.057,0.877h4.201c0.573,0,1.058-0.401,1.058-0.877v-3.744c0-0.478-0.484-0.882-1.058-0.882H125.506z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.136,221.424h4.201c0.856,0,1.557-0.621,1.557-1.377v-3.744c0-0.759-0.699-1.382-1.557-1.382 h-4.201c-0.856,0-1.558,0.623-1.558,1.382v3.744C114.578,220.803,115.28,221.424,116.136,221.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.337,221.924h-4.201c-1.135,0-2.058-0.842-2.058-1.877v-3.744 c0-1.038,0.923-1.882,2.058-1.882h4.201c1.134,0,2.057,0.844,2.057,1.882v3.744 C122.394,221.082,121.471,221.924,120.337,221.924z M116.136,215.421c-0.573,0-1.058,0.404-1.058,0.882v3.744 c0,0.476,0.484,0.877,1.058,0.877h4.201c0.573,0,1.057-0.401,1.057-0.877v-3.744c0-0.478-0.484-0.882-1.057-0.882H116.136z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.768,221.424h4.2c0.857,0,1.558-0.621,1.558-1.377v-3.744c0-0.759-0.699-1.382-1.558-1.382 h-4.2c-0.855,0-1.558,0.623-1.558,1.382v3.744C105.21,220.803,105.911,221.424,106.768,221.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.968,221.924h-4.2c-1.135,0-2.058-0.842-2.058-1.877v-3.744c0-1.038,0.923-1.882,2.058-1.882 h4.2c1.135,0,2.058,0.844,2.058,1.882v3.744C113.026,221.082,112.103,221.924,110.968,221.924z M106.768,215.421 c-0.573,0-1.058,0.404-1.058,0.882v3.744c0,0.476,0.484,0.877,1.058,0.877h4.2c0.573,0,1.058-0.401,1.058-0.877v-3.744 c0-0.478-0.484-0.882-1.058-0.882H106.768z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.221,216.303c0-0.759-0.7-1.382-1.558-1.382H56.856c-0.856,0-1.558,0.623-1.558,1.382v3.744 c0,0.756,0.7,1.377,1.558,1.377h16.809c0.856,0,1.558-0.621,1.558-1.377L75.221,216.303L75.221,216.303z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.664,221.924H56.856c-1.135,0-2.058-0.842-2.058-1.877v-3.744 c0-1.038,0.923-1.882,2.058-1.882h16.808c1.135,0,2.058,0.844,2.058,1.882l0.001,3.744 C75.722,221.082,74.799,221.924,73.664,221.924z M56.856,215.421c-0.573,0-1.058,0.404-1.058,0.882v3.744 c0,0.476,0.484,0.877,1.058,0.877h16.809c0.573,0,1.058-0.401,1.058-0.877v-3.744c0-0.478-0.485-0.882-1.059-0.882H56.856z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.959,214.921h-13.563c-0.854,0-1.557,0.623-1.557,1.382v3.744 c0,0.756,0.702,1.377,1.557,1.377h13.563c0.856,0,1.559-0.621,1.559-1.377v-3.744 C159.516,215.544,158.817,214.921,157.959,214.921z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.959,221.924h-13.563c-1.134,0-2.057-0.842-2.057-1.877v-3.744 c0-1.038,0.923-1.882,2.057-1.882h13.563c1.133,0,2.056,0.844,2.059,1.881v3.745 C160.018,221.082,159.094,221.924,157.959,221.924z M144.396,215.421c-0.573,0-1.057,0.404-1.057,0.882v3.744 c0,0.476,0.483,0.877,1.057,0.877h13.563c0.574,0,1.059-0.401,1.059-0.877v-3.744c-0.001-0.478-0.486-0.882-1.059-0.882H144.396 z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.435,223.688h-4.579c-0.856,0-1.558,0.621-1.558,1.381v3.742c0,0.758,0.7,1.381,1.558,1.381 h4.579c0.856,0,1.558-0.623,1.558-1.381v-3.742C62.991,224.309,62.291,223.688,61.435,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.435,230.691h-4.579c-1.135,0-2.058-0.844-2.058-1.881v-3.742 c0-1.037,0.923-1.881,2.058-1.881h4.579c1.133,0,2.056,0.844,2.058,1.88v3.743C63.492,229.848,62.57,230.691,61.435,230.691z  M56.856,224.188c-0.573,0-1.058,0.403-1.058,0.881v3.742c0,0.478,0.484,0.881,1.058,0.881h4.579 c0.573,0,1.058-0.403,1.058-0.881v-3.742c0-0.478-0.485-0.881-1.058-0.881H56.856z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.467,223.688h-4.58c-0.854,0-1.557,0.621-1.557,1.381v3.742c0,0.758,0.701,1.381,1.557,1.381 h4.58c0.856,0,1.557-0.623,1.557-1.381v-3.742C73.025,224.309,72.324,223.688,71.467,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.467,230.691h-4.58c-1.134,0-2.057-0.844-2.057-1.881v-3.742c0-1.037,0.922-1.881,2.057-1.881 h4.58c0.576,0,1.13,0.224,1.519,0.613c0.347,0.348,0.538,0.798,0.538,1.269v3.741C73.524,229.848,72.601,230.691,71.467,230.691 z M66.887,224.188c-0.573,0-1.057,0.403-1.057,0.881v3.742c0,0.478,0.484,0.881,1.057,0.881h4.58 c0.573,0,1.057-0.403,1.057-0.881v-3.742c0-0.203-0.087-0.402-0.245-0.561c-0.203-0.203-0.499-0.32-0.812-0.32H66.887z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2,223.688h-4.579c-0.856,0-1.558,0.621-1.558,1.381v3.742c0,0.758,0.7,1.381,1.558,1.381 H81.2c0.856,0,1.559-0.623,1.559-1.381v-3.742C82.759,224.309,82.058,223.688,81.2,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2,230.691h-4.579c-1.135,0-2.058-0.844-2.058-1.881v-3.742c0-1.037,0.923-1.881,2.058-1.881 H81.2c1.135,0,2.059,0.844,2.059,1.881v3.742C83.259,229.848,82.336,230.691,81.2,230.691z M76.621,224.188 c-0.573,0-1.058,0.403-1.058,0.881v3.742c0,0.478,0.484,0.881,1.058,0.881H81.2c0.574,0,1.059-0.403,1.059-0.881v-3.742 c0-0.478-0.485-0.881-1.059-0.881H76.621z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.372,223.688H86.746c-0.856,0-1.558,0.621-1.558,1.381v3.742c0,0.758,0.7,1.381,1.558,1.381 h36.626c0.854,0,1.558-0.623,1.558-1.381v-3.742C124.93,224.309,124.228,223.688,123.372,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.372,230.691H86.746c-1.135,0-2.058-0.844-2.058-1.881v-3.742 c0-1.037,0.923-1.881,2.058-1.881h36.626c1.135,0,2.058,0.844,2.058,1.881v3.742 C125.43,229.848,124.507,230.691,123.372,230.691z M86.746,224.188c-0.573,0-1.058,0.403-1.058,0.881v3.742 c0,0.478,0.484,0.881,1.058,0.881h36.626c0.573,0,1.058-0.403,1.058-0.881v-3.742c0-0.478-0.484-0.881-1.058-0.881H86.746z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.404,223.688h-5.734c-0.857,0-1.559,0.621-1.559,1.381v3.742c0,0.758,0.7,1.381,1.559,1.381 h5.734c0.856,0,1.559-0.623,1.559-1.381v-3.742C135.961,224.309,135.26,223.688,134.404,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.404,230.691h-5.734c-1.135,0-2.059-0.844-2.059-1.881v-3.742 c0-1.037,0.923-1.881,2.059-1.881h5.734c1.134,0,2.058,0.844,2.059,1.88v3.743C136.462,229.848,135.538,230.691,134.404,230.691 z M128.669,224.188c-0.574,0-1.059,0.403-1.059,0.881v3.742c0,0.478,0.485,0.881,1.059,0.881h5.734 c0.574,0,1.059-0.403,1.059-0.881v-3.742c-0.001-0.478-0.485-0.881-1.059-0.881H128.669z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.959,223.688h-5.734c-0.856,0-1.557,0.621-1.557,1.381v3.742 c0,0.758,0.699,1.381,1.557,1.381h5.734c0.856,0,1.559-0.623,1.559-1.381v-3.742 C159.516,224.309,158.817,223.688,157.959,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.959,230.691h-5.734c-1.134,0-2.057-0.844-2.057-1.881v-3.742 c0-1.037,0.923-1.881,2.057-1.881h5.734c1.133,0,2.056,0.843,2.059,1.88v3.743C160.018,229.848,159.094,230.691,157.959,230.691 z M152.225,224.188c-0.573,0-1.057,0.403-1.057,0.881v3.742c0,0.478,0.483,0.881,1.057,0.881h5.734 c0.574,0,1.059-0.403,1.059-0.881v-3.742c-0.001-0.485-0.477-0.881-1.059-0.881H152.225z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.605,196.466h4.2c0.856,0,1.557-0.62,1.557-1.378v-3.744c0-0.759-0.7-1.378-1.557-1.378h-4.2 c-0.855,0-1.557,0.619-1.557,1.378v3.744C71.048,195.845,71.748,196.466,72.605,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.805,196.966h-4.2c-1.134,0-2.057-0.843-2.057-1.878v-3.744c0-1.035,0.922-1.878,2.057-1.878 h4.2c1.134,0,2.057,0.843,2.057,1.878v3.744C78.862,196.123,77.939,196.966,76.805,196.966z M72.605,190.466 c-0.573,0-1.057,0.402-1.057,0.878v3.744c0,0.476,0.484,0.878,1.057,0.878h4.2c0.573,0,1.057-0.402,1.057-0.878v-3.744 c0-0.476-0.484-0.878-1.057-0.878H72.605z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.966,196.466h4.198c0.857,0,1.558-0.62,1.558-1.378v-3.744c0-0.759-0.699-1.378-1.558-1.378 h-4.198c-0.858,0-1.558,0.619-1.558,1.378v3.744C101.409,195.845,102.109,196.466,102.966,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.164,196.966h-4.198c-1.133,0-2.056-0.842-2.058-1.877v-3.745 c0-1.035,0.923-1.878,2.058-1.878h4.198c1.135,0,2.058,0.843,2.058,1.878v3.744 C109.222,196.123,108.299,196.966,107.164,196.966z M102.966,190.466c-0.583,0-1.058,0.394-1.058,0.878v3.744 c0,0.476,0.485,0.878,1.058,0.878h4.198c0.573,0,1.058-0.402,1.058-0.878v-3.744c0-0.484-0.475-0.878-1.058-0.878H102.966z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.569,196.466h4.199c0.855,0,1.56-0.62,1.56-1.378v-3.744c0-0.759-0.703-1.378-1.56-1.378 h-4.199c-0.854,0-1.557,0.619-1.557,1.378v3.744C152.012,195.845,152.713,196.466,153.569,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.768,196.966h-4.199c-1.134,0-2.057-0.843-2.057-1.878v-3.744 c0-1.035,0.923-1.878,2.057-1.878h4.199c1.136,0,2.06,0.843,2.06,1.878v3.744C159.827,196.123,158.904,196.966,157.768,196.966z  M153.569,190.466c-0.573,0-1.057,0.402-1.057,0.878v3.744c0,0.476,0.483,0.878,1.057,0.878h4.199 c0.574,0,1.06-0.402,1.06-0.878v-3.744c0-0.476-0.485-0.878-1.06-0.878H153.569z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.087,196.466h4.2c0.854,0,1.557-0.62,1.557-1.378v-3.744c0-0.759-0.701-1.378-1.557-1.378 h-4.2c-0.856,0-1.559,0.619-1.559,1.378v3.744C111.53,195.845,112.231,196.466,113.087,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.287,196.966h-4.2c-1.134,0-2.057-0.842-2.059-1.877v-3.745c0-1.035,0.923-1.878,2.059-1.878 h4.2c1.134,0,2.057,0.843,2.057,1.878v3.744C119.344,196.123,118.422,196.966,117.287,196.966z M113.087,190.466 c-0.574,0-1.059,0.402-1.059,0.878v3.744c0,0.476,0.485,0.878,1.059,0.878h4.2c0.573,0,1.057-0.402,1.057-0.878v-3.744 c0-0.476-0.484-0.878-1.057-0.878H113.087z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.845,196.466h4.199c0.856,0,1.558-0.62,1.558-1.378v-3.744c0-0.759-0.7-1.378-1.558-1.378 h-4.199c-0.855,0-1.557,0.619-1.557,1.378v3.744C91.288,195.845,91.99,196.466,92.845,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.044,196.966h-4.199c-1.134,0-2.057-0.843-2.057-1.878v-3.744 c0-1.035,0.922-1.878,2.057-1.878h4.199c1.135,0,2.058,0.843,2.058,1.878v3.744C99.102,196.123,98.179,196.966,97.044,196.966z  M92.845,190.466c-0.573,0-1.057,0.402-1.057,0.878v3.744c0,0.476,0.484,0.878,1.057,0.878h4.199 c0.573,0,1.058-0.402,1.058-0.878v-3.744c0-0.484-0.475-0.878-1.058-0.878H92.845z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.448,196.466h4.198c0.857,0,1.56-0.62,1.56-1.378v-3.744c0-0.759-0.701-1.378-1.56-1.378 h-4.198c-0.856,0-1.558,0.619-1.558,1.378v3.744C141.891,195.845,142.591,196.466,143.448,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.647,196.966h-4.198c-1.135,0-2.058-0.843-2.058-1.878v-3.744 c0-1.035,0.923-1.878,2.058-1.878h4.198c1.136,0,2.06,0.843,2.06,1.878v3.744C149.706,196.123,148.782,196.966,147.647,196.966z  M143.448,190.466c-0.573,0-1.058,0.402-1.058,0.878v3.744c0,0.476,0.484,0.878,1.058,0.878h4.198 c0.574,0,1.06-0.402,1.06-0.878v-3.744c0-0.484-0.476-0.878-1.06-0.878H143.448z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.207,196.466h4.199c0.855,0,1.559-0.62,1.559-1.378v-3.744c0-0.759-0.702-1.378-1.559-1.378 h-4.199c-0.856,0-1.559,0.619-1.559,1.378v3.744C121.65,195.845,122.351,196.466,123.207,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.406,196.966h-4.199c-1.134,0-2.057-0.842-2.059-1.877v-3.745 c0-1.035,0.923-1.878,2.059-1.878h4.199c1.135,0,2.059,0.843,2.059,1.878v3.744 C129.465,196.123,128.541,196.966,127.406,196.966z M123.207,190.466c-0.574,0-1.059,0.402-1.059,0.878v3.744 c0,0.476,0.485,0.878,1.059,0.878h4.199c0.574,0,1.059-0.402,1.059-0.878v-3.744c0-0.476-0.485-0.878-1.059-0.878H123.207z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.328,196.466h4.198c0.857,0,1.559-0.62,1.559-1.378v-3.744c0-0.759-0.7-1.378-1.559-1.378 h-4.198c-0.857,0-1.559,0.619-1.559,1.378v3.744C131.771,195.845,132.471,196.466,133.328,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.527,196.966h-4.198c-1.134,0-2.058-0.842-2.059-1.877v-3.745 c0-1.035,0.924-1.878,2.059-1.878h4.198c1.135,0,2.059,0.843,2.059,1.878v3.744 C139.585,196.123,138.661,196.966,137.527,196.966z M133.328,190.466c-0.574,0-1.059,0.402-1.059,0.878v3.744 c0.001,0.476,0.485,0.878,1.059,0.878h4.198c0.574,0,1.059-0.402,1.059-0.878v-3.744c0-0.484-0.475-0.878-1.059-0.878H133.328z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.726,196.466h4.198c0.857,0,1.558-0.62,1.558-1.378v-3.744c0-0.759-0.699-1.378-1.558-1.378 h-4.198c-0.856,0-1.559,0.619-1.559,1.378v3.744C81.167,195.845,81.868,196.466,82.726,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.924,196.966h-4.198c-1.135,0-2.059-0.843-2.059-1.878v-3.744 c0-1.035,0.923-1.878,2.059-1.878h4.198c1.135,0,2.058,0.843,2.058,1.878v3.744C88.982,196.123,88.059,196.966,86.924,196.966z  M82.726,190.466c-0.574,0-1.059,0.402-1.059,0.878v3.744c0,0.476,0.485,0.878,1.059,0.878h4.198 c0.573,0,1.058-0.402,1.058-0.878v-3.744c0-0.484-0.475-0.878-1.058-0.878H82.726z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.753,196.466h10.004c0.855,0,1.557-0.62,1.557-1.378v-3.744c0-0.759-0.699-1.378-1.557-1.378 H56.753c-0.857,0-1.559,0.619-1.559,1.378v3.744C55.196,195.845,55.896,196.466,56.753,196.466z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.757,196.966H56.753c-1.134,0-2.057-0.842-2.059-1.877v-3.745 c0-1.035,0.923-1.878,2.059-1.878h10.004c1.134,0,2.057,0.843,2.057,1.878v3.744C68.814,196.123,67.891,196.966,66.757,196.966z  M56.753,190.466c-0.574,0-1.059,0.402-1.059,0.878v3.744c0,0.476,0.485,0.878,1.059,0.878h10.004 c0.573,0,1.057-0.402,1.057-0.878v-3.744c0-0.484-0.474-0.878-1.057-0.878H56.753z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.38,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.047,223.688h-5.734c-0.856,0-1.557,0.621-1.557,1.381v3.742 c0,0.758,0.699,1.381,1.557,1.381h5.734c0.856,0,1.559-0.623,1.559-1.381v-3.742 C147.606,224.309,146.905,223.688,146.047,223.688z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.047,230.691h-5.734c-1.134,0-2.057-0.844-2.057-1.881v-3.742 c0-1.037,0.923-1.881,2.057-1.881h5.734c1.135,0,2.059,0.844,2.059,1.881v3.742 C148.106,229.848,147.182,230.691,146.047,230.691z M140.313,224.188c-0.573,0-1.057,0.403-1.057,0.881v3.742 c0,0.478,0.483,0.881,1.057,0.881h5.734c0.574,0,1.059-0.403,1.059-0.881v-3.742c0-0.478-0.484-0.881-1.059-0.881H140.313z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M165.004,185.633c0.016,0.305,0.022,0.611,0.022,0.928 v39.812c0,3.496-0.741,6.354-6.352,6.359l-104.105,0.1c-3.102,0.002-4.711-0.872-5.533-2.242c0.151,3.055,1.224,5.423,6.327,5.419 l104.104-0.101c5.611-0.004,6.354-2.863,6.354-6.358v-39.812C165.823,188.175,165.67,186.742,165.004,185.633z",
    style: {
      opacity: 0.15,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.959,165.242h-3.636C73.323,165.242,74.969,165.602,76.959,165.242z M131.942,155.186V142.85 h-48.08v11.854c0,7.771-3.854,9.995-6.902,10.536h6.902v3.292h48.08v-3.292h10.539C132.842,165.242,132,157.244,131.942,155.186z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.442,170.032h-51.08v-3.292H77.1c-0.636,0.107-1.298,0.162-1.968,0.162c0,0,0,0,0,0 c-1.204,0-2.038-0.175-2.128-0.194l0.32-2.966h3.488c3.683-0.708,5.55-3.748,5.55-9.038V141.35h51.08v13.836 c0.073,2.542,1.101,8.555,9.034,8.555v3h-9.034V170.032z M85.362,167.032h45.08v-3.292h3.483 c-2.364-2.24-3.396-5.435-3.482-8.512l-0.001-10.879h-45.08v10.354c0,4.416-1.177,7.237-2.736,9.036h2.736V167.032z  M142.481,166.74v-0.118V166.74l-0.004-3v1.5l0.004-1.5V166.74z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 6.589,
    width: 69.158,
    style: {
      fill: "#F2F2F2"
    },
    y: 165.242,
    x: 73.323
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.482,173.331H73.323c-0.829,0-1.5-0.672-1.5-1.5v-6.589c0-0.828,0.671-1.5,1.5-1.5h69.158 c0.828,0,1.5,0.672,1.5,1.5v6.589C143.982,172.659,143.31,173.331,142.482,173.331z M74.823,170.331h66.158v-3.589H74.823 V170.331z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.594,125.064V19.021c0-7.245,5.927-13.172,13.174-13.172h142.271 c7.245,0,13.173,5.928,13.173,13.172v106.043",
    style: {
      fill: "#BBC0D9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 90.099,
    width: 148.546,
    style: {
      fill: "#A3ACD9"
    },
    y: 15.745,
    x: 33.145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.211,114.527v15.147c0,7.247-5.929,13.174-13.173,13.174H36.768 c-7.248,0-13.174-5.929-13.174-13.174v-15.147H192.211z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 6.053,
    width: 148.546,
    style: {
      opacity: 0.51,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 15.745,
    x: 33.145
  }), /*#__PURE__*/React.createElement("rect", {
    height: 84.046,
    width: 55.19,
    style: {
      opacity: 0.51,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 21.798,
    x: 76.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 84.046,
    width: 44.819,
    style: {
      opacity: 0.51,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 21.798,
    x: 135.278
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.074,
    width: 105.2,
    style: {
      fill: "#A3ACD9"
    },
    y: 101.255,
    x: 74.899
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.077,
    width: 65.935,
    style: {
      fill: "#A3ACD9"
    },
    y: 79.583,
    x: 69.343
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 55.192,
    style: {
      fill: "#A3ACD9"
    },
    y: 27.225,
    x: 76.38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.926,
    width: 15.743,
    style: {
      fill: "#A3ACD9"
    },
    y: 21.798,
    x: 75.269
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.926,
    width: 44.819,
    style: {
      fill: "#A3ACD9"
    },
    y: 21.798,
    x: 135.278
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 21.115,
    style: {
      fill: "#CCCCDE"
    },
    y: 28.336,
    x: 42.301
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 22.042,
    style: {
      fill: "#CCCCDE"
    },
    y: 33.708,
    x: 47.671
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 16.763,
    style: {
      fill: "#CCCCDE"
    },
    y: 39.449,
    x: 47.671
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.482,4.574H36.211c-7.246,0-13.173,5.927-13.173,13.173v5.557 c0-7.246,5.927-13.173,13.173-13.173h142.271c7.245,0,13.173,5.927,13.173,13.173v-5.557 C191.656,10.501,185.727,4.574,178.482,4.574z",
    style: {
      fill: "#D5DBF7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 7.38,
    style: {
      fill: "#CCCCDE"
    },
    y: 45.375,
    x: 47.671
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 7.222,
    style: {
      fill: "#CCCCDE"
    },
    y: 32.689,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 12.502,
    style: {
      fill: "#FFFF9C"
    },
    y: 32.689,
    x: 100.087
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 13.891,
    style: {
      fill: "#CCCCDE"
    },
    y: 36.022,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 6.111,
    style: {
      fill: "#FFFF9C"
    },
    y: 36.022,
    x: 105.921
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 8.613,
    style: {
      fill: "#CCCCDE"
    },
    y: 39.912,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.335,
    style: {
      fill: "#FFFF9C"
    },
    y: 39.912,
    x: 100.919
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11.113,
    style: {
      fill: "#CCCCDE"
    },
    y: 43.523,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10.836,
    style: {
      fill: "#CCCCDE"
    },
    y: 46.857,
    x: 93.697
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.613,
    style: {
      fill: "#FFFF9C"
    },
    y: 46.857,
    x: 108.976
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 14.17,
    style: {
      fill: "#FFFF9C"
    },
    y: 46.857,
    x: 114.254
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.501,
    style: {
      fill: "#CCCCDE"
    },
    y: 51.024,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 6.527,
    style: {
      fill: "#CCCCDE"
    },
    y: 54.637,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 9.794,
    style: {
      fill: "#CCCCDE"
    },
    y: 58.248,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.057,
    style: {
      fill: "#FFFF9C"
    },
    y: 58.248,
    x: 102.865
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11.667,
    style: {
      fill: "#CCCCDE"
    },
    y: 62.693,
    x: 87.585
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 9.168,
    style: {
      fill: "#CCCCDE"
    },
    y: 66.305,
    x: 91.474
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.611,
    style: {
      fill: "#CCCCDE"
    },
    y: 66.305,
    x: 102.865
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.334,
    style: {
      fill: "#FFFF9C"
    },
    y: 66.305,
    x: 110.365
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 13.612,
    style: {
      fill: "#CCCCDE"
    },
    y: 70.472,
    x: 91.474
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.224,
    style: {
      fill: "#FFFF9C"
    },
    y: 70.472,
    x: 110.365
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.777,
    style: {
      fill: "#CCCCDE"
    },
    y: 74.361,
    x: 87.585
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 36.022,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 39.912,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 43.385,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 46.765,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 51.024,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 54.637,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 58.248,
    x: 80.361
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.739,
    style: {
      fill: "#CCCCDE"
    },
    y: 62.693,
    x: 80.456
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.739,
    style: {
      fill: "#CCCCDE"
    },
    y: 66.305,
    x: 80.456
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.739,
    style: {
      fill: "#CCCCDE"
    },
    y: 70.472,
    x: 80.456
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.739,
    style: {
      fill: "#CCCCDE"
    },
    y: 74.361,
    x: 80.456
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 0.835,
    style: {
      fill: "#CCCCDE"
    },
    y: 32.689,
    x: 80.361
  })), /*#__PURE__*/React.createElement("rect", {
    height: 48.525,
    width: 0.25,
    style: {
      fill: "#5FEAFF"
    },
    y: 31.058,
    x: 84.405
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 6.962,
    style: {
      fill: "#A1FFD2"
    },
    y: 32.226,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 12.047,
    style: {
      fill: "#CCCCDE"
    },
    y: 32.226,
    x: 150.382
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 13.388,
    style: {
      fill: "#FCBAFF"
    },
    y: 35.56,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 5.89,
    style: {
      fill: "#CCCCDE"
    },
    y: 35.56,
    x: 156.004
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 8.3,
    style: {
      fill: "#CCCCDE"
    },
    y: 39.449,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.211,
    style: {
      fill: "#FCBAFF"
    },
    y: 39.449,
    x: 151.186
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10.711,
    style: {
      fill: "#CCCCDE"
    },
    y: 43.061,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10.442,
    style: {
      fill: "#CCCCDE"
    },
    y: 46.394,
    x: 144.224
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.48,
    style: {
      fill: "#FCBAFF"
    },
    y: 46.394,
    x: 158.948
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 13.652,
    style: {
      fill: "#CCCCDE"
    },
    y: 46.394,
    x: 164.037
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.408,
    style: {
      fill: "#CCCCDE"
    },
    y: 50.561,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 6.293,
    style: {
      fill: "#CCCCDE"
    },
    y: 54.173,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 9.438,
    style: {
      fill: "#CCCCDE"
    },
    y: 57.785,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.946,
    style: {
      fill: "#CCCCDE"
    },
    y: 57.785,
    x: 153.058
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 11.245,
    style: {
      fill: "#A1FFD2"
    },
    y: 62.229,
    x: 138.332
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 8.839,
    style: {
      fill: "#CCCCDE"
    },
    y: 65.841,
    x: 142.08
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.483,
    style: {
      fill: "#CCCCDE"
    },
    y: 65.841,
    x: 153.058
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3.214,
    style: {
      fill: "#CCCCDE"
    },
    y: 65.841,
    x: 160.287
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 13.121,
    style: {
      fill: "#FCBAFF"
    },
    y: 70.008,
    x: 142.08
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.142,
    style: {
      fill: "#CCCCDE"
    },
    y: 70.008,
    x: 160.287
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 2.678,
    style: {
      fill: "#CCCCDE"
    },
    y: 73.898,
    x: 138.332
  })), /*#__PURE__*/React.createElement("rect", {
    height: 84.046,
    width: 0.5,
    style: {
      fill: "#6E6E96"
    },
    y: 21.798,
    x: 40.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.038,144.348H36.768c-8.091,0-14.674-6.583-14.674-14.674v-16.647h171.617v16.647 C193.711,137.765,187.129,144.348,179.038,144.348z M25.094,116.027v13.647c0,6.437,5.237,11.674,11.674,11.674h142.271 c6.437,0,11.673-5.237,11.673-11.674v-13.647H25.094z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.711,125.064h-3V19.021c0-6.436-5.236-11.672-11.673-11.672H36.768 c-6.437,0-11.674,5.236-11.674,11.672v106.043h-3V19.021c0-8.09,6.583-14.672,14.674-14.672h142.271 c8.091,0,14.673,6.582,14.673,14.672V125.064z",
    style: {
      fill: "#6E6E96"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.037,136.461H36.768 c-7.248,0-13.174-5.93-13.174-13.174v6.388c0,7.247,5.927,13.175,13.174,13.175h142.271c7.245,0,13.173-5.93,13.173-13.175v-6.388 C192.211,130.531,186.282,136.461,179.037,136.461z",
    style: {
      opacity: 0.15,
      fill: "#6E6E96",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.275,
    width: 168.616,
    style: {
      opacity: 0.15,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 109.252,
    x: 23.594
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8.407,
    width: 48.08,
    style: {
      opacity: 0.15,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 142.85,
    x: 83.862
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6.589,
    width: 19.612,
    style: {
      opacity: 0.15,
      fill: "#6E6E96",
      enableBackground: "new"
    },
    y: 165.242,
    x: 122.867
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.866,129.424h-11.112c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h11.112 c0.829,0,1.5,0.672,1.5,1.5S113.695,129.424,112.866,129.424z",
    style: {
      fill: "#6E6E96"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.145,52.358 63.705,21.798 109.532,21.798  33.835,97.498",
    style: {
      opacity: 0.17,
      fill: "#FFFFFF",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.573,21.798 47.138,106.234 60.081,106.234  144.517,21.798",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.691,107.344H33.145c-0.829,0-1.5-0.671-1.5-1.5V15.745c0-0.829,0.671-1.5,1.5-1.5h148.546 c0.828,0,1.5,0.671,1.5,1.5v90.099C183.191,106.672,182.519,107.344,181.691,107.344z M34.645,104.344h145.546V17.245H34.645 V104.344z",
    style: {
      fill: "#6E6E96"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.dbc95c25415059b96baa98fe2cf0e1f7.svg";
export { ForwardRef as ReactComponent };